webpackJsonp([35783957827783],{

/***/ 327:
/***/ (function(module, exports) {

	module.exports = { prefix: 'far', iconName: 'file-alt', icon: [384, 512, [], "f15c", "M288 248v28c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-28c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm-12 72H108c-6.6 0-12 5.4-12 12v28c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12v-28c0-6.6-5.4-12-12-12zm108-188.1V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48C0 21.5 21.5 0 48 0h204.1C264.8 0 277 5.1 286 14.1L369.9 98c9 8.9 14.1 21.2 14.1 33.9zm-128-80V128h76.1L256 51.9zM336 464V176H232c-13.3 0-24-10.7-24-24V48H48v416h288z"] };

/***/ }),

/***/ 328:
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * Font Awesome Free 5.0.13 by @fontawesome - https://fontawesome.com
	 * License - https://fontawesome.com/license (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
	 */
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.fontawesome = {})));
	}(this, (function (exports) { 'use strict';
	
	var noop = function noop() {};
	
	var _WINDOW = {};
	var _DOCUMENT = {};
	var _MUTATION_OBSERVER$1 = null;
	var _PERFORMANCE = { mark: noop, measure: noop };
	
	try {
	  if (typeof window !== 'undefined') _WINDOW = window;
	  if (typeof document !== 'undefined') _DOCUMENT = document;
	  if (typeof MutationObserver !== 'undefined') _MUTATION_OBSERVER$1 = MutationObserver;
	  if (typeof performance !== 'undefined') _PERFORMANCE = performance;
	} catch (e) {}
	
	var _ref = _WINDOW.navigator || {};
	var _ref$userAgent = _ref.userAgent;
	var userAgent = _ref$userAgent === undefined ? '' : _ref$userAgent;
	
	var WINDOW = _WINDOW;
	var DOCUMENT = _DOCUMENT;
	var MUTATION_OBSERVER = _MUTATION_OBSERVER$1;
	var PERFORMANCE = _PERFORMANCE;
	var IS_BROWSER = !!WINDOW.document;
	var IS_DOM = !!DOCUMENT.documentElement && !!DOCUMENT.head && typeof DOCUMENT.addEventListener === 'function' && typeof DOCUMENT.createElement === 'function';
	var IS_IE = ~userAgent.indexOf('MSIE') || ~userAgent.indexOf('Trident/');
	
	var NAMESPACE_IDENTIFIER = '___FONT_AWESOME___';
	var UNITS_IN_GRID = 16;
	var DEFAULT_FAMILY_PREFIX = 'fa';
	var DEFAULT_REPLACEMENT_CLASS = 'svg-inline--fa';
	var DATA_FA_I2SVG = 'data-fa-i2svg';
	var DATA_FA_PSEUDO_ELEMENT = 'data-fa-pseudo-element';
	var HTML_CLASS_I2SVG_BASE_CLASS = 'fontawesome-i2svg';
	
	var PRODUCTION = function () {
	  try {
	    return ("production") === 'production';
	  } catch (e) {
	    return false;
	  }
	}();
	
	var oneToTen = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
	var oneToTwenty = oneToTen.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]);
	
	var ATTRIBUTES_WATCHED_FOR_MUTATION = ['class', 'data-prefix', 'data-icon', 'data-fa-transform', 'data-fa-mask'];
	
	var RESERVED_CLASSES = ['xs', 'sm', 'lg', 'fw', 'ul', 'li', 'border', 'pull-left', 'pull-right', 'spin', 'pulse', 'rotate-90', 'rotate-180', 'rotate-270', 'flip-horizontal', 'flip-vertical', 'stack', 'stack-1x', 'stack-2x', 'inverse', 'layers', 'layers-text', 'layers-counter'].concat(oneToTen.map(function (n) {
	  return n + 'x';
	})).concat(oneToTwenty.map(function (n) {
	  return 'w-' + n;
	}));
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	
	
	var toConsumableArray = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
	
	    return arr2;
	  } else {
	    return Array.from(arr);
	  }
	};
	
	var initial = WINDOW.FontAwesomeConfig || {};
	var initialKeys = Object.keys(initial);
	
	var _default = _extends({
	  familyPrefix: DEFAULT_FAMILY_PREFIX,
	  replacementClass: DEFAULT_REPLACEMENT_CLASS,
	  autoReplaceSvg: true,
	  autoAddCss: true,
	  autoA11y: true,
	  searchPseudoElements: false,
	  observeMutations: true,
	  keepOriginalSource: true,
	  measurePerformance: false,
	  showMissingIcons: true
	}, initial);
	
	if (!_default.autoReplaceSvg) _default.observeMutations = false;
	
	var config$1 = _extends({}, _default);
	
	WINDOW.FontAwesomeConfig = config$1;
	
	function update(newConfig) {
	  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var _params$asNewDefault = params.asNewDefault,
	      asNewDefault = _params$asNewDefault === undefined ? false : _params$asNewDefault;
	
	  var validKeys = Object.keys(config$1);
	  var ok = asNewDefault ? function (k) {
	    return ~validKeys.indexOf(k) && !~initialKeys.indexOf(k);
	  } : function (k) {
	    return ~validKeys.indexOf(k);
	  };
	
	  Object.keys(newConfig).forEach(function (configKey) {
	    if (ok(configKey)) config$1[configKey] = newConfig[configKey];
	  });
	}
	
	function auto(value) {
	  update({
	    autoReplaceSvg: value,
	    observeMutations: value
	  });
	}
	
	var w = WINDOW || {};
	
	if (!w[NAMESPACE_IDENTIFIER]) w[NAMESPACE_IDENTIFIER] = {};
	if (!w[NAMESPACE_IDENTIFIER].styles) w[NAMESPACE_IDENTIFIER].styles = {};
	if (!w[NAMESPACE_IDENTIFIER].hooks) w[NAMESPACE_IDENTIFIER].hooks = {};
	if (!w[NAMESPACE_IDENTIFIER].shims) w[NAMESPACE_IDENTIFIER].shims = [];
	
	var namespace = w[NAMESPACE_IDENTIFIER];
	
	var functions = [];
	var listener = function listener() {
	  DOCUMENT.removeEventListener('DOMContentLoaded', listener);
	  loaded = 1;
	  functions.map(function (fn) {
	    return fn();
	  });
	};
	
	var loaded = false;
	
	if (IS_DOM) {
	  loaded = (DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(DOCUMENT.readyState);
	
	  if (!loaded) DOCUMENT.addEventListener('DOMContentLoaded', listener);
	}
	
	var domready = function (fn) {
	  if (!IS_DOM) return;
	  loaded ? setTimeout(fn, 0) : functions.push(fn);
	};
	
	var d = UNITS_IN_GRID;
	
	var meaninglessTransform = {
	  size: 16,
	  x: 0,
	  y: 0,
	  rotate: 0,
	  flipX: false,
	  flipY: false
	};
	
	function isReserved(name) {
	  return ~RESERVED_CLASSES.indexOf(name);
	}
	
	function bunker(fn) {
	  try {
	    fn();
	  } catch (e) {
	    if (!PRODUCTION) {
	      throw e;
	    }
	  }
	}
	
	function insertCss(css) {
	  if (!css || !IS_DOM) {
	    return;
	  }
	
	  var style = DOCUMENT.createElement('style');
	  style.setAttribute('type', 'text/css');
	  style.innerHTML = css;
	
	  var headChildren = DOCUMENT.head.childNodes;
	  var beforeChild = null;
	
	  for (var i = headChildren.length - 1; i > -1; i--) {
	    var child = headChildren[i];
	    var tagName = (child.tagName || '').toUpperCase();
	    if (['STYLE', 'LINK'].indexOf(tagName) > -1) {
	      beforeChild = child;
	    }
	  }
	
	  DOCUMENT.head.insertBefore(style, beforeChild);
	
	  return css;
	}
	
	var _uniqueId = 0;
	
	function nextUniqueId() {
	  _uniqueId++;
	
	  return _uniqueId;
	}
	
	function toArray(obj) {
	  var array = [];
	
	  for (var i = (obj || []).length >>> 0; i--;) {
	    array[i] = obj[i];
	  }
	
	  return array;
	}
	
	function classArray(node) {
	  if (node.classList) {
	    return toArray(node.classList);
	  } else {
	    return (node.getAttribute('class') || '').split(' ').filter(function (i) {
	      return i;
	    });
	  }
	}
	
	function getIconName(familyPrefix, cls) {
	  var parts = cls.split('-');
	  var prefix = parts[0];
	  var iconName = parts.slice(1).join('-');
	
	  if (prefix === familyPrefix && iconName !== '' && !isReserved(iconName)) {
	    return iconName;
	  } else {
	    return null;
	  }
	}
	
	function htmlEscape(str) {
	  return ('' + str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
	}
	
	function joinAttributes(attributes) {
	  return Object.keys(attributes || {}).reduce(function (acc, attributeName) {
	    return acc + (attributeName + '="' + htmlEscape(attributes[attributeName]) + '" ');
	  }, '').trim();
	}
	
	function joinStyles(styles) {
	  return Object.keys(styles || {}).reduce(function (acc, styleName) {
	    return acc + (styleName + ': ' + styles[styleName] + ';');
	  }, '');
	}
	
	function transformIsMeaningful(transform) {
	  return transform.size !== meaninglessTransform.size || transform.x !== meaninglessTransform.x || transform.y !== meaninglessTransform.y || transform.rotate !== meaninglessTransform.rotate || transform.flipX || transform.flipY;
	}
	
	function transformForSvg(_ref) {
	  var transform = _ref.transform,
	      containerWidth = _ref.containerWidth,
	      iconWidth = _ref.iconWidth;
	
	  var outer = {
	    transform: 'translate(' + containerWidth / 2 + ' 256)'
	  };
	  var innerTranslate = 'translate(' + transform.x * 32 + ', ' + transform.y * 32 + ') ';
	  var innerScale = 'scale(' + transform.size / 16 * (transform.flipX ? -1 : 1) + ', ' + transform.size / 16 * (transform.flipY ? -1 : 1) + ') ';
	  var innerRotate = 'rotate(' + transform.rotate + ' 0 0)';
	  var inner = {
	    transform: innerTranslate + ' ' + innerScale + ' ' + innerRotate
	  };
	  var path = {
	    transform: 'translate(' + iconWidth / 2 * -1 + ' -256)'
	  };
	  return {
	    outer: outer,
	    inner: inner,
	    path: path
	  };
	}
	
	function transformForCss(_ref2) {
	  var transform = _ref2.transform,
	      _ref2$width = _ref2.width,
	      width = _ref2$width === undefined ? UNITS_IN_GRID : _ref2$width,
	      _ref2$height = _ref2.height,
	      height = _ref2$height === undefined ? UNITS_IN_GRID : _ref2$height,
	      _ref2$startCentered = _ref2.startCentered,
	      startCentered = _ref2$startCentered === undefined ? false : _ref2$startCentered;
	
	  var val = '';
	
	  if (startCentered && IS_IE) {
	    val += 'translate(' + (transform.x / d - width / 2) + 'em, ' + (transform.y / d - height / 2) + 'em) ';
	  } else if (startCentered) {
	    val += 'translate(calc(-50% + ' + transform.x / d + 'em), calc(-50% + ' + transform.y / d + 'em)) ';
	  } else {
	    val += 'translate(' + transform.x / d + 'em, ' + transform.y / d + 'em) ';
	  }
	
	  val += 'scale(' + transform.size / d * (transform.flipX ? -1 : 1) + ', ' + transform.size / d * (transform.flipY ? -1 : 1) + ') ';
	  val += 'rotate(' + transform.rotate + 'deg) ';
	
	  return val;
	}
	
	var ALL_SPACE = {
	  x: 0,
	  y: 0,
	  width: '100%',
	  height: '100%'
	};
	
	var makeIconMasking = function (_ref) {
	  var children = _ref.children,
	      attributes = _ref.attributes,
	      main = _ref.main,
	      mask = _ref.mask,
	      transform = _ref.transform;
	  var mainWidth = main.width,
	      mainPath = main.icon;
	  var maskWidth = mask.width,
	      maskPath = mask.icon;
	
	
	  var trans = transformForSvg({ transform: transform, containerWidth: maskWidth, iconWidth: mainWidth });
	
	  var maskRect = {
	    tag: 'rect',
	    attributes: _extends({}, ALL_SPACE, {
	      fill: 'white'
	    })
	  };
	  var maskInnerGroup = {
	    tag: 'g',
	    attributes: _extends({}, trans.inner),
	    children: [{ tag: 'path', attributes: _extends({}, mainPath.attributes, trans.path, { fill: 'black' }) }]
	  };
	  var maskOuterGroup = {
	    tag: 'g',
	    attributes: _extends({}, trans.outer),
	    children: [maskInnerGroup]
	  };
	  var maskId = 'mask-' + nextUniqueId();
	  var clipId = 'clip-' + nextUniqueId();
	  var maskTag = {
	    tag: 'mask',
	    attributes: _extends({}, ALL_SPACE, {
	      id: maskId,
	      maskUnits: 'userSpaceOnUse',
	      maskContentUnits: 'userSpaceOnUse'
	    }),
	    children: [maskRect, maskOuterGroup]
	  };
	  var defs = {
	    tag: 'defs',
	    children: [{ tag: 'clipPath', attributes: { id: clipId }, children: [maskPath] }, maskTag]
	  };
	
	  children.push(defs, { tag: 'rect', attributes: _extends({ fill: 'currentColor', 'clip-path': 'url(#' + clipId + ')', mask: 'url(#' + maskId + ')' }, ALL_SPACE) });
	
	  return {
	    children: children,
	    attributes: attributes
	  };
	};
	
	var makeIconStandard = function (_ref) {
	  var children = _ref.children,
	      attributes = _ref.attributes,
	      main = _ref.main,
	      transform = _ref.transform,
	      styles = _ref.styles;
	
	  var styleString = joinStyles(styles);
	
	  if (styleString.length > 0) {
	    attributes['style'] = styleString;
	  }
	
	  if (transformIsMeaningful(transform)) {
	    var trans = transformForSvg({ transform: transform, containerWidth: main.width, iconWidth: main.width });
	    children.push({
	      tag: 'g',
	      attributes: _extends({}, trans.outer),
	      children: [{
	        tag: 'g',
	        attributes: _extends({}, trans.inner),
	        children: [{
	          tag: main.icon.tag,
	          children: main.icon.children,
	          attributes: _extends({}, main.icon.attributes, trans.path)
	        }]
	      }]
	    });
	  } else {
	    children.push(main.icon);
	  }
	
	  return {
	    children: children,
	    attributes: attributes
	  };
	};
	
	var asIcon = function (_ref) {
	  var children = _ref.children,
	      main = _ref.main,
	      mask = _ref.mask,
	      attributes = _ref.attributes,
	      styles = _ref.styles,
	      transform = _ref.transform;
	
	  if (transformIsMeaningful(transform) && main.found && !mask.found) {
	    var width = main.width,
	        height = main.height;
	
	    var offset = {
	      x: width / height / 2,
	      y: 0.5
	    };
	    attributes['style'] = joinStyles(_extends({}, styles, {
	      'transform-origin': offset.x + transform.x / 16 + 'em ' + (offset.y + transform.y / 16) + 'em'
	    }));
	  }
	
	  return [{
	    tag: 'svg',
	    attributes: attributes,
	    children: children
	  }];
	};
	
	var asSymbol = function (_ref) {
	  var prefix = _ref.prefix,
	      iconName = _ref.iconName,
	      children = _ref.children,
	      attributes = _ref.attributes,
	      symbol = _ref.symbol;
	
	  var id = symbol === true ? prefix + '-' + config$1.familyPrefix + '-' + iconName : symbol;
	
	  return [{
	    tag: 'svg',
	    attributes: {
	      style: 'display: none;'
	    },
	    children: [{
	      tag: 'symbol',
	      attributes: _extends({}, attributes, { id: id }),
	      children: children
	    }]
	  }];
	};
	
	function makeInlineSvgAbstract(params) {
	  var _params$icons = params.icons,
	      main = _params$icons.main,
	      mask = _params$icons.mask,
	      prefix = params.prefix,
	      iconName = params.iconName,
	      transform = params.transform,
	      symbol = params.symbol,
	      title = params.title,
	      extra = params.extra,
	      _params$watchable = params.watchable,
	      watchable = _params$watchable === undefined ? false : _params$watchable;
	
	  var _ref = mask.found ? mask : main,
	      width = _ref.width,
	      height = _ref.height;
	
	  var widthClass = 'fa-w-' + Math.ceil(width / height * 16);
	  var attrClass = [config$1.replacementClass, iconName ? config$1.familyPrefix + '-' + iconName : '', widthClass].concat(extra.classes).join(' ');
	
	  var content = {
	    children: [],
	    attributes: _extends({}, extra.attributes, {
	      'data-prefix': prefix,
	      'data-icon': iconName,
	      'class': attrClass,
	      'role': 'img',
	      'xmlns': 'http://www.w3.org/2000/svg',
	      'viewBox': '0 0 ' + width + ' ' + height
	    })
	  };
	
	  if (watchable) {
	    content.attributes[DATA_FA_I2SVG] = '';
	  }
	
	  if (title) content.children.push({ tag: 'title', attributes: { id: content.attributes['aria-labelledby'] || 'title-' + nextUniqueId() }, children: [title] });
	
	  var args = _extends({}, content, {
	    prefix: prefix,
	    iconName: iconName,
	    main: main,
	    mask: mask,
	    transform: transform,
	    symbol: symbol,
	    styles: extra.styles
	  });
	
	  var _ref2 = mask.found && main.found ? makeIconMasking(args) : makeIconStandard(args),
	      children = _ref2.children,
	      attributes = _ref2.attributes;
	
	  args.children = children;
	  args.attributes = attributes;
	
	  if (symbol) {
	    return asSymbol(args);
	  } else {
	    return asIcon(args);
	  }
	}
	
	function makeLayersTextAbstract(params) {
	  var content = params.content,
	      width = params.width,
	      height = params.height,
	      transform = params.transform,
	      title = params.title,
	      extra = params.extra,
	      _params$watchable2 = params.watchable,
	      watchable = _params$watchable2 === undefined ? false : _params$watchable2;
	
	
	  var attributes = _extends({}, extra.attributes, title ? { 'title': title } : {}, {
	    'class': extra.classes.join(' ')
	  });
	
	  if (watchable) {
	    attributes[DATA_FA_I2SVG] = '';
	  }
	
	  var styles = _extends({}, extra.styles);
	
	  if (transformIsMeaningful(transform)) {
	    styles['transform'] = transformForCss({ transform: transform, startCentered: true, width: width, height: height });
	    styles['-webkit-transform'] = styles['transform'];
	  }
	
	  var styleString = joinStyles(styles);
	
	  if (styleString.length > 0) {
	    attributes['style'] = styleString;
	  }
	
	  var val = [];
	
	  val.push({
	    tag: 'span',
	    attributes: attributes,
	    children: [content]
	  });
	
	  if (title) {
	    val.push({ tag: 'span', attributes: { class: 'sr-only' }, children: [title] });
	  }
	
	  return val;
	}
	
	var noop$2 = function noop() {};
	var p = config$1.measurePerformance && PERFORMANCE && PERFORMANCE.mark && PERFORMANCE.measure ? PERFORMANCE : { mark: noop$2, measure: noop$2 };
	var preamble = 'FA "5.0.13"';
	
	var begin = function begin(name) {
	  p.mark(preamble + ' ' + name + ' begins');
	  return function () {
	    return end(name);
	  };
	};
	
	var end = function end(name) {
	  p.mark(preamble + ' ' + name + ' ends');
	  p.measure(preamble + ' ' + name, preamble + ' ' + name + ' begins', preamble + ' ' + name + ' ends');
	};
	
	var perf = { begin: begin, end: end };
	
	'use strict';
	
	/**
	 * Internal helper to bind a function known to have 4 arguments
	 * to a given context.
	 */
	var bindInternal4 = function bindInternal4 (func, thisContext) {
	  return function (a, b, c, d) {
	    return func.call(thisContext, a, b, c, d);
	  };
	};
	
	'use strict';
	
	
	
	/**
	 * # Reduce
	 *
	 * A fast object `.reduce()` implementation.
	 *
	 * @param  {Object}   subject      The object to reduce over.
	 * @param  {Function} fn           The reducer function.
	 * @param  {mixed}    initialValue The initial value for the reducer, defaults to subject[0].
	 * @param  {Object}   thisContext  The context for the reducer.
	 * @return {mixed}                 The final result.
	 */
	var reduce = function fastReduceObject (subject, fn, initialValue, thisContext) {
	  var keys = Object.keys(subject),
	      length = keys.length,
	      iterator = thisContext !== undefined ? bindInternal4(fn, thisContext) : fn,
	      i, key, result;
	
	  if (initialValue === undefined) {
	    i = 1;
	    result = subject[keys[0]];
	  }
	  else {
	    i = 0;
	    result = initialValue;
	  }
	
	  for (; i < length; i++) {
	    key = keys[i];
	    result = iterator(result, subject[key], key, subject);
	  }
	
	  return result;
	};
	
	var styles$2 = namespace.styles;
	var shims = namespace.shims;
	
	
	var _byUnicode = {};
	var _byLigature = {};
	var _byOldName = {};
	
	var build = function build() {
	  var lookup = function lookup(reducer) {
	    return reduce(styles$2, function (o, style, prefix) {
	      o[prefix] = reduce(style, reducer, {});
	      return o;
	    }, {});
	  };
	
	  _byUnicode = lookup(function (acc, icon, iconName) {
	    acc[icon[3]] = iconName;
	
	    return acc;
	  });
	
	  _byLigature = lookup(function (acc, icon, iconName) {
	    var ligatures = icon[2];
	
	    acc[iconName] = iconName;
	
	    ligatures.forEach(function (ligature) {
	      acc[ligature] = iconName;
	    });
	
	    return acc;
	  });
	
	  var hasRegular = 'far' in styles$2;
	
	  _byOldName = reduce(shims, function (acc, shim) {
	    var oldName = shim[0];
	    var prefix = shim[1];
	    var iconName = shim[2];
	
	    if (prefix === 'far' && !hasRegular) {
	      prefix = 'fas';
	    }
	
	    acc[oldName] = { prefix: prefix, iconName: iconName };
	
	    return acc;
	  }, {});
	};
	
	build();
	
	function byUnicode(prefix, unicode) {
	  return _byUnicode[prefix][unicode];
	}
	
	function byLigature(prefix, ligature) {
	  return _byLigature[prefix][ligature];
	}
	
	function byOldName(name) {
	  return _byOldName[name] || { prefix: null, iconName: null };
	}
	
	var styles$1 = namespace.styles;
	
	
	var emptyCanonicalIcon = function emptyCanonicalIcon() {
	  return { prefix: null, iconName: null, rest: [] };
	};
	
	function getCanonicalIcon(values) {
	  return values.reduce(function (acc, cls) {
	    var iconName = getIconName(config$1.familyPrefix, cls);
	
	    if (styles$1[cls]) {
	      acc.prefix = cls;
	    } else if (iconName) {
	      var shim = acc.prefix === 'fa' ? byOldName(iconName) : {};
	
	      acc.iconName = shim.iconName || iconName;
	      acc.prefix = shim.prefix || acc.prefix;
	    } else if (cls !== config$1.replacementClass && cls.indexOf('fa-w-') !== 0) {
	      acc.rest.push(cls);
	    }
	
	    return acc;
	  }, emptyCanonicalIcon());
	}
	
	function iconFromMapping(mapping, prefix, iconName) {
	  if (mapping && mapping[prefix] && mapping[prefix][iconName]) {
	    return {
	      prefix: prefix,
	      iconName: iconName,
	      icon: mapping[prefix][iconName]
	    };
	  }
	}
	
	function toHtml(abstractNodes) {
	  var tag = abstractNodes.tag,
	      _abstractNodes$attrib = abstractNodes.attributes,
	      attributes = _abstractNodes$attrib === undefined ? {} : _abstractNodes$attrib,
	      _abstractNodes$childr = abstractNodes.children,
	      children = _abstractNodes$childr === undefined ? [] : _abstractNodes$childr;
	
	
	  if (typeof abstractNodes === 'string') {
	    return htmlEscape(abstractNodes);
	  } else {
	    return '<' + tag + ' ' + joinAttributes(attributes) + '>' + children.map(toHtml).join('') + '</' + tag + '>';
	  }
	}
	
	var noop$1 = function noop() {};
	
	function isWatched(node) {
	  var i2svg = node.getAttribute ? node.getAttribute(DATA_FA_I2SVG) : null;
	
	  return typeof i2svg === 'string';
	}
	
	function getMutator() {
	  if (config$1.autoReplaceSvg === true) {
	    return mutators.replace;
	  }
	
	  var mutator = mutators[config$1.autoReplaceSvg];
	
	  return mutator || mutators.replace;
	}
	
	var mutators = {
	  replace: function replace(mutation) {
	    var node = mutation[0];
	    var abstract = mutation[1];
	    var newOuterHTML = abstract.map(function (a) {
	      return toHtml(a);
	    }).join('\n');
	
	    if (node.parentNode && node.outerHTML) {
	      node.outerHTML = newOuterHTML + (config$1.keepOriginalSource && node.tagName.toLowerCase() !== 'svg' ? '<!-- ' + node.outerHTML + ' -->' : '');
	    } else if (node.parentNode) {
	      var newNode = document.createElement('span');
	      node.parentNode.replaceChild(newNode, node);
	      newNode.outerHTML = newOuterHTML;
	    }
	  },
	  nest: function nest(mutation) {
	    var node = mutation[0];
	    var abstract = mutation[1];
	
	    // If we already have a replaced node we do not want to continue nesting within it.
	    // Short-circuit to the standard replacement
	    if (~classArray(node).indexOf(config$1.replacementClass)) {
	      return mutators.replace(mutation);
	    }
	
	    var forSvg = new RegExp(config$1.familyPrefix + '-.*');
	
	    delete abstract[0].attributes.style;
	
	    var splitClasses = abstract[0].attributes.class.split(' ').reduce(function (acc, cls) {
	      if (cls === config$1.replacementClass || cls.match(forSvg)) {
	        acc.toSvg.push(cls);
	      } else {
	        acc.toNode.push(cls);
	      }
	
	      return acc;
	    }, { toNode: [], toSvg: [] });
	
	    abstract[0].attributes.class = splitClasses.toSvg.join(' ');
	
	    var newInnerHTML = abstract.map(function (a) {
	      return toHtml(a);
	    }).join('\n');
	    node.setAttribute('class', splitClasses.toNode.join(' '));
	    node.setAttribute(DATA_FA_I2SVG, '');
	    node.innerHTML = newInnerHTML;
	  }
	};
	
	function perform(mutations, callback) {
	  var callbackFunction = typeof callback === 'function' ? callback : noop$1;
	
	  if (mutations.length === 0) {
	    callbackFunction();
	  } else {
	    var frame = WINDOW.requestAnimationFrame || function (op) {
	      return op();
	    };
	
	    frame(function () {
	      var mutator = getMutator();
	      var mark = perf.begin('mutate');
	
	      mutations.map(mutator);
	
	      mark();
	
	      callbackFunction();
	    });
	  }
	}
	
	var disabled = false;
	
	function disableObservation(operation) {
	  disabled = true;
	  operation();
	  disabled = false;
	}
	
	var mo = null;
	
	function observe(options) {
	  if (!MUTATION_OBSERVER) return;
	
	  var treeCallback = options.treeCallback,
	      nodeCallback = options.nodeCallback,
	      pseudoElementsCallback = options.pseudoElementsCallback;
	
	
	  mo = new MUTATION_OBSERVER(function (objects) {
	    if (disabled) return;
	
	    toArray(objects).forEach(function (mutationRecord) {
	      if (mutationRecord.type === 'childList' && mutationRecord.addedNodes.length > 0 && !isWatched(mutationRecord.addedNodes[0])) {
	        if (config$1.searchPseudoElements) {
	          pseudoElementsCallback(mutationRecord.target);
	        }
	
	        treeCallback(mutationRecord.target);
	      }
	
	      if (mutationRecord.type === 'attributes' && mutationRecord.target.parentNode && config$1.searchPseudoElements) {
	        pseudoElementsCallback(mutationRecord.target.parentNode);
	      }
	
	      if (mutationRecord.type === 'attributes' && isWatched(mutationRecord.target) && ~ATTRIBUTES_WATCHED_FOR_MUTATION.indexOf(mutationRecord.attributeName)) {
	        if (mutationRecord.attributeName === 'class') {
	          var _getCanonicalIcon = getCanonicalIcon(classArray(mutationRecord.target)),
	              prefix = _getCanonicalIcon.prefix,
	              iconName = _getCanonicalIcon.iconName;
	
	          if (prefix) mutationRecord.target.setAttribute('data-prefix', prefix);
	          if (iconName) mutationRecord.target.setAttribute('data-icon', iconName);
	        } else {
	          nodeCallback(mutationRecord.target);
	        }
	      }
	    });
	  });
	
	  if (!IS_DOM) return;
	
	  mo.observe(DOCUMENT.getElementsByTagName('body')[0], {
	    childList: true, attributes: true, characterData: true, subtree: true
	  });
	}
	
	function disconnect() {
	  if (!mo) return;
	
	  mo.disconnect();
	}
	
	var styleParser = function (node) {
	  var style = node.getAttribute('style');
	
	  var val = [];
	
	  if (style) {
	    val = style.split(';').reduce(function (acc, style) {
	      var styles = style.split(':');
	      var prop = styles[0];
	      var value = styles.slice(1);
	
	      if (prop && value.length > 0) {
	        acc[prop] = value.join(':').trim();
	      }
	
	      return acc;
	    }, {});
	  }
	
	  return val;
	};
	
	function toHex(unicode) {
	  var result = '';
	
	  for (var i = 0; i < unicode.length; i++) {
	    var hex = unicode.charCodeAt(i).toString(16);
	    result += ('000' + hex).slice(-4);
	  }
	
	  return result;
	}
	
	var classParser = function (node) {
	  var existingPrefix = node.getAttribute('data-prefix');
	  var existingIconName = node.getAttribute('data-icon');
	  var innerText = node.innerText !== undefined ? node.innerText.trim() : '';
	
	  var val = getCanonicalIcon(classArray(node));
	
	  if (existingPrefix && existingIconName) {
	    val.prefix = existingPrefix;
	    val.iconName = existingIconName;
	  }
	
	  if (val.prefix && innerText.length > 1) {
	    val.iconName = byLigature(val.prefix, node.innerText);
	  } else if (val.prefix && innerText.length === 1) {
	    val.iconName = byUnicode(val.prefix, toHex(node.innerText));
	  }
	
	  return val;
	};
	
	var parseTransformString = function parseTransformString(transformString) {
	  var transform = {
	    size: 16,
	    x: 0,
	    y: 0,
	    flipX: false,
	    flipY: false,
	    rotate: 0
	  };
	
	  if (!transformString) {
	    return transform;
	  } else {
	    return transformString.toLowerCase().split(' ').reduce(function (acc, n) {
	      var parts = n.toLowerCase().split('-');
	      var first = parts[0];
	      var rest = parts.slice(1).join('-');
	
	      if (first && rest === 'h') {
	        acc.flipX = true;
	        return acc;
	      }
	
	      if (first && rest === 'v') {
	        acc.flipY = true;
	        return acc;
	      }
	
	      rest = parseFloat(rest);
	
	      if (isNaN(rest)) {
	        return acc;
	      }
	
	      switch (first) {
	        case 'grow':
	          acc.size = acc.size + rest;
	          break;
	        case 'shrink':
	          acc.size = acc.size - rest;
	          break;
	        case 'left':
	          acc.x = acc.x - rest;
	          break;
	        case 'right':
	          acc.x = acc.x + rest;
	          break;
	        case 'up':
	          acc.y = acc.y - rest;
	          break;
	        case 'down':
	          acc.y = acc.y + rest;
	          break;
	        case 'rotate':
	          acc.rotate = acc.rotate + rest;
	          break;
	      }
	
	      return acc;
	    }, transform);
	  }
	};
	
	var transformParser = function (node) {
	  return parseTransformString(node.getAttribute('data-fa-transform'));
	};
	
	var symbolParser = function (node) {
	  var symbol = node.getAttribute('data-fa-symbol');
	
	  return symbol === null ? false : symbol === '' ? true : symbol;
	};
	
	var attributesParser = function (node) {
	  var extraAttributes = toArray(node.attributes).reduce(function (acc, attr) {
	    if (acc.name !== 'class' && acc.name !== 'style') {
	      acc[attr.name] = attr.value;
	    }
	    return acc;
	  }, {});
	
	  var title = node.getAttribute('title');
	
	  if (config$1.autoA11y) {
	    if (title) {
	      extraAttributes['aria-labelledby'] = config$1.replacementClass + '-title-' + nextUniqueId();
	    } else {
	      extraAttributes['aria-hidden'] = 'true';
	    }
	  }
	
	  return extraAttributes;
	};
	
	var maskParser = function (node) {
	  var mask = node.getAttribute('data-fa-mask');
	
	  if (!mask) {
	    return emptyCanonicalIcon();
	  } else {
	    return getCanonicalIcon(mask.split(' ').map(function (i) {
	      return i.trim();
	    }));
	  }
	};
	
	function parseMeta(node) {
	  var _classParser = classParser(node),
	      iconName = _classParser.iconName,
	      prefix = _classParser.prefix,
	      extraClasses = _classParser.rest;
	
	  var extraStyles = styleParser(node);
	  var transform = transformParser(node);
	  var symbol = symbolParser(node);
	  var extraAttributes = attributesParser(node);
	  var mask = maskParser(node);
	
	  return {
	    iconName: iconName,
	    title: node.getAttribute('title'),
	    prefix: prefix,
	    transform: transform,
	    symbol: symbol,
	    mask: mask,
	    extra: {
	      classes: extraClasses,
	      styles: extraStyles,
	      attributes: extraAttributes
	    }
	  };
	}
	
	function MissingIcon(error) {
	  this.name = 'MissingIcon';
	  this.message = error || 'Icon unavailable';
	  this.stack = new Error().stack;
	}
	
	MissingIcon.prototype = Object.create(Error.prototype);
	MissingIcon.prototype.constructor = MissingIcon;
	
	var FILL = { fill: 'currentColor' };
	var ANIMATION_BASE = {
	  attributeType: 'XML',
	  repeatCount: 'indefinite',
	  dur: '2s'
	};
	var RING = {
	  tag: 'path',
	  attributes: _extends({}, FILL, {
	    d: 'M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z'
	  })
	};
	var OPACITY_ANIMATE = _extends({}, ANIMATION_BASE, {
	  attributeName: 'opacity'
	});
	var DOT = {
	  tag: 'circle',
	  attributes: _extends({}, FILL, {
	    cx: '256',
	    cy: '364',
	    r: '28'
	  }),
	  children: [{ tag: 'animate', attributes: _extends({}, ANIMATION_BASE, { attributeName: 'r', values: '28;14;28;28;14;28;' }) }, { tag: 'animate', attributes: _extends({}, OPACITY_ANIMATE, { values: '1;0;1;1;0;1;' }) }]
	};
	var QUESTION = {
	  tag: 'path',
	  attributes: _extends({}, FILL, {
	    opacity: '1',
	    d: 'M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z'
	  }),
	  children: [{ tag: 'animate', attributes: _extends({}, OPACITY_ANIMATE, { values: '1;0;0;0;0;1;' }) }]
	};
	var EXCLAMATION = {
	  tag: 'path',
	  attributes: _extends({}, FILL, {
	    opacity: '0',
	    d: 'M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z'
	  }),
	  children: [{ tag: 'animate', attributes: _extends({}, OPACITY_ANIMATE, { values: '0;0;1;1;0;0;' }) }]
	};
	
	var missing = { tag: 'g', children: [RING, DOT, QUESTION, EXCLAMATION] };
	
	var styles = namespace.styles;
	
	var LAYERS_TEXT_CLASSNAME = 'fa-layers-text';
	var FONT_FAMILY_PATTERN = /Font Awesome 5 (Solid|Regular|Light|Brands)/;
	var STYLE_TO_PREFIX = {
	  'Solid': 'fas',
	  'Regular': 'far',
	  'Light': 'fal',
	  'Brands': 'fab'
	};
	
	function findIcon(iconName, prefix) {
	  var val = {
	    found: false,
	    width: 512,
	    height: 512,
	    icon: missing
	  };
	
	  if (iconName && prefix && styles[prefix] && styles[prefix][iconName]) {
	    var icon = styles[prefix][iconName];
	    var width = icon[0];
	    var height = icon[1];
	    var vectorData = icon.slice(4);
	
	    val = {
	      found: true,
	      width: width,
	      height: height,
	      icon: { tag: 'path', attributes: { fill: 'currentColor', d: vectorData[0] } }
	    };
	  } else if (iconName && prefix && !config$1.showMissingIcons) {
	    throw new MissingIcon('Icon is missing for prefix ' + prefix + ' with icon name ' + iconName);
	  }
	
	  return val;
	}
	
	function generateSvgReplacementMutation(node, nodeMeta) {
	  var iconName = nodeMeta.iconName,
	      title = nodeMeta.title,
	      prefix = nodeMeta.prefix,
	      transform = nodeMeta.transform,
	      symbol = nodeMeta.symbol,
	      mask = nodeMeta.mask,
	      extra = nodeMeta.extra;
	
	
	  return [node, makeInlineSvgAbstract({
	    icons: {
	      main: findIcon(iconName, prefix),
	      mask: findIcon(mask.iconName, mask.prefix)
	    },
	    prefix: prefix,
	    iconName: iconName,
	    transform: transform,
	    symbol: symbol,
	    mask: mask,
	    title: title,
	    extra: extra,
	    watchable: true
	  })];
	}
	
	function generateLayersText(node, nodeMeta) {
	  var title = nodeMeta.title,
	      transform = nodeMeta.transform,
	      extra = nodeMeta.extra;
	
	
	  var width = null;
	  var height = null;
	
	  if (IS_IE) {
	    var computedFontSize = parseInt(getComputedStyle(node).fontSize, 10);
	    var boundingClientRect = node.getBoundingClientRect();
	    width = boundingClientRect.width / computedFontSize;
	    height = boundingClientRect.height / computedFontSize;
	  }
	
	  if (config$1.autoA11y && !title) {
	    extra.attributes['aria-hidden'] = 'true';
	  }
	
	  return [node, makeLayersTextAbstract({
	    content: node.innerHTML,
	    width: width,
	    height: height,
	    transform: transform,
	    title: title,
	    extra: extra,
	    watchable: true
	  })];
	}
	
	function generateMutation(node) {
	  var nodeMeta = parseMeta(node);
	
	  if (~nodeMeta.extra.classes.indexOf(LAYERS_TEXT_CLASSNAME)) {
	    return generateLayersText(node, nodeMeta);
	  } else {
	    return generateSvgReplacementMutation(node, nodeMeta);
	  }
	}
	
	function remove(node) {
	  if (typeof node.remove === 'function') {
	    node.remove();
	  } else if (node && node.parentNode) {
	    node.parentNode.removeChild(node);
	  }
	}
	
	function searchPseudoElements(root) {
	  if (!IS_DOM) return;
	
	  var end = perf.begin('searchPseudoElements');
	
	  disableObservation(function () {
	    toArray(root.querySelectorAll('*')).forEach(function (node) {
	      [':before', ':after'].forEach(function (pos) {
	        var styles = WINDOW.getComputedStyle(node, pos);
	        var fontFamily = styles.getPropertyValue('font-family').match(FONT_FAMILY_PATTERN);
	        var children = toArray(node.children);
	        var pseudoElement = children.filter(function (c) {
	          return c.getAttribute(DATA_FA_PSEUDO_ELEMENT) === pos;
	        })[0];
	
	        if (pseudoElement) {
	          if (pseudoElement.nextSibling && pseudoElement.nextSibling.textContent.indexOf(DATA_FA_PSEUDO_ELEMENT) > -1) {
	            remove(pseudoElement.nextSibling);
	          }
	          remove(pseudoElement);
	          pseudoElement = null;
	        }
	
	        if (fontFamily && !pseudoElement) {
	          var content = styles.getPropertyValue('content');
	          var i = DOCUMENT.createElement('i');
	          i.setAttribute('class', '' + STYLE_TO_PREFIX[fontFamily[1]]);
	          i.setAttribute(DATA_FA_PSEUDO_ELEMENT, pos);
	          i.innerText = content.length === 3 ? content.substr(1, 1) : content;
	          if (pos === ':before') {
	            node.insertBefore(i, node.firstChild);
	          } else {
	            node.appendChild(i);
	          }
	        }
	      });
	    });
	  });
	
	  end();
	}
	
	function onTree(root) {
	  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	  if (!IS_DOM) return;
	
	  var htmlClassList = DOCUMENT.documentElement.classList;
	  var hclAdd = function hclAdd(suffix) {
	    return htmlClassList.add(HTML_CLASS_I2SVG_BASE_CLASS + '-' + suffix);
	  };
	  var hclRemove = function hclRemove(suffix) {
	    return htmlClassList.remove(HTML_CLASS_I2SVG_BASE_CLASS + '-' + suffix);
	  };
	  var prefixes = Object.keys(styles);
	  var prefixesDomQuery = ['.' + LAYERS_TEXT_CLASSNAME + ':not([' + DATA_FA_I2SVG + '])'].concat(prefixes.map(function (p) {
	    return '.' + p + ':not([' + DATA_FA_I2SVG + '])';
	  })).join(', ');
	
	  if (prefixesDomQuery.length === 0) {
	    return;
	  }
	
	  var candidates = toArray(root.querySelectorAll(prefixesDomQuery));
	
	  if (candidates.length > 0) {
	    hclAdd('pending');
	    hclRemove('complete');
	  } else {
	    return;
	  }
	
	  var mark = perf.begin('onTree');
	
	  var mutations = candidates.reduce(function (acc, node) {
	    try {
	      var mutation = generateMutation(node);
	
	      if (mutation) {
	        acc.push(mutation);
	      }
	    } catch (e) {
	      if (!PRODUCTION) {
	        if (e instanceof MissingIcon) {
	          console.error(e);
	        }
	      }
	    }
	
	    return acc;
	  }, []);
	
	  mark();
	
	  perform(mutations, function () {
	    hclAdd('active');
	    hclAdd('complete');
	    hclRemove('pending');
	
	    if (typeof callback === 'function') callback();
	  });
	}
	
	function onNode(node) {
	  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	  var mutation = generateMutation(node);
	
	  if (mutation) {
	    perform([mutation], callback);
	  }
	}
	
	var baseStyles = "svg:not(:root).svg-inline--fa {\n  overflow: visible; }\n\n.svg-inline--fa {\n  display: inline-block;\n  font-size: inherit;\n  height: 1em;\n  overflow: visible;\n  vertical-align: -.125em; }\n  .svg-inline--fa.fa-lg {\n    vertical-align: -.225em; }\n  .svg-inline--fa.fa-w-1 {\n    width: 0.0625em; }\n  .svg-inline--fa.fa-w-2 {\n    width: 0.125em; }\n  .svg-inline--fa.fa-w-3 {\n    width: 0.1875em; }\n  .svg-inline--fa.fa-w-4 {\n    width: 0.25em; }\n  .svg-inline--fa.fa-w-5 {\n    width: 0.3125em; }\n  .svg-inline--fa.fa-w-6 {\n    width: 0.375em; }\n  .svg-inline--fa.fa-w-7 {\n    width: 0.4375em; }\n  .svg-inline--fa.fa-w-8 {\n    width: 0.5em; }\n  .svg-inline--fa.fa-w-9 {\n    width: 0.5625em; }\n  .svg-inline--fa.fa-w-10 {\n    width: 0.625em; }\n  .svg-inline--fa.fa-w-11 {\n    width: 0.6875em; }\n  .svg-inline--fa.fa-w-12 {\n    width: 0.75em; }\n  .svg-inline--fa.fa-w-13 {\n    width: 0.8125em; }\n  .svg-inline--fa.fa-w-14 {\n    width: 0.875em; }\n  .svg-inline--fa.fa-w-15 {\n    width: 0.9375em; }\n  .svg-inline--fa.fa-w-16 {\n    width: 1em; }\n  .svg-inline--fa.fa-w-17 {\n    width: 1.0625em; }\n  .svg-inline--fa.fa-w-18 {\n    width: 1.125em; }\n  .svg-inline--fa.fa-w-19 {\n    width: 1.1875em; }\n  .svg-inline--fa.fa-w-20 {\n    width: 1.25em; }\n  .svg-inline--fa.fa-pull-left {\n    margin-right: .3em;\n    width: auto; }\n  .svg-inline--fa.fa-pull-right {\n    margin-left: .3em;\n    width: auto; }\n  .svg-inline--fa.fa-border {\n    height: 1.5em; }\n  .svg-inline--fa.fa-li {\n    width: 2em; }\n  .svg-inline--fa.fa-fw {\n    width: 1.25em; }\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0; }\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -.125em;\n  width: 1em; }\n  .fa-layers svg.svg-inline--fa {\n    -webkit-transform-origin: center center;\n            transform-origin: center center; }\n\n.fa-layers-text, .fa-layers-counter {\n  display: inline-block;\n  position: absolute;\n  text-align: center; }\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -webkit-transform-origin: center center;\n          transform-origin: center center; }\n\n.fa-layers-counter {\n  background-color: #ff253a;\n  border-radius: 1em;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  color: #fff;\n  height: 1.5em;\n  line-height: 1;\n  max-width: 5em;\n  min-width: 1.5em;\n  overflow: hidden;\n  padding: .25em;\n  right: 0;\n  text-overflow: ellipsis;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top right;\n          transform-origin: top right; }\n\n.fa-layers-bottom-right {\n  bottom: 0;\n  right: 0;\n  top: auto;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: bottom right;\n          transform-origin: bottom right; }\n\n.fa-layers-bottom-left {\n  bottom: 0;\n  left: 0;\n  right: auto;\n  top: auto;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: bottom left;\n          transform-origin: bottom left; }\n\n.fa-layers-top-right {\n  right: 0;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top right;\n          transform-origin: top right; }\n\n.fa-layers-top-left {\n  left: 0;\n  right: auto;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top left;\n          transform-origin: top left; }\n\n.fa-lg {\n  font-size: 1.33333em;\n  line-height: 0.75em;\n  vertical-align: -.0667em; }\n\n.fa-xs {\n  font-size: .75em; }\n\n.fa-sm {\n  font-size: .875em; }\n\n.fa-1x {\n  font-size: 1em; }\n\n.fa-2x {\n  font-size: 2em; }\n\n.fa-3x {\n  font-size: 3em; }\n\n.fa-4x {\n  font-size: 4em; }\n\n.fa-5x {\n  font-size: 5em; }\n\n.fa-6x {\n  font-size: 6em; }\n\n.fa-7x {\n  font-size: 7em; }\n\n.fa-8x {\n  font-size: 8em; }\n\n.fa-9x {\n  font-size: 9em; }\n\n.fa-10x {\n  font-size: 10em; }\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em; }\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: 2.5em;\n  padding-left: 0; }\n  .fa-ul > li {\n    position: relative; }\n\n.fa-li {\n  left: -2em;\n  position: absolute;\n  text-align: center;\n  width: 2em;\n  line-height: inherit; }\n\n.fa-border {\n  border: solid 0.08em #eee;\n  border-radius: .1em;\n  padding: .2em .25em .15em; }\n\n.fa-pull-left {\n  float: left; }\n\n.fa-pull-right {\n  float: right; }\n\n.fa.fa-pull-left,\n.fas.fa-pull-left,\n.far.fa-pull-left,\n.fal.fa-pull-left,\n.fab.fa-pull-left {\n  margin-right: .3em; }\n\n.fa.fa-pull-right,\n.fas.fa-pull-right,\n.far.fa-pull-right,\n.fal.fa-pull-right,\n.fab.fa-pull-right {\n  margin-left: .3em; }\n\n.fa-spin {\n  -webkit-animation: fa-spin 2s infinite linear;\n          animation: fa-spin 2s infinite linear; }\n\n.fa-pulse {\n  -webkit-animation: fa-spin 1s infinite steps(8);\n          animation: fa-spin 1s infinite steps(8); }\n\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg); } }\n\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg); } }\n\n.fa-rotate-90 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg); }\n\n.fa-rotate-180 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg); }\n\n.fa-rotate-270 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg); }\n\n.fa-flip-horizontal {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1); }\n\n.fa-flip-vertical {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1); }\n\n.fa-flip-horizontal.fa-flip-vertical {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1); }\n\n:root .fa-rotate-90,\n:root .fa-rotate-180,\n:root .fa-rotate-270,\n:root .fa-flip-horizontal,\n:root .fa-flip-vertical {\n  -webkit-filter: none;\n          filter: none; }\n\n.fa-stack {\n  display: inline-block;\n  height: 2em;\n  position: relative;\n  width: 2em; }\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0; }\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1em; }\n\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2em; }\n\n.fa-inverse {\n  color: #fff; }\n\n.sr-only {\n  border: 0;\n  clip: rect(0, 0, 0, 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px; }\n\n.sr-only-focusable:active, .sr-only-focusable:focus {\n  clip: auto;\n  height: auto;\n  margin: 0;\n  overflow: visible;\n  position: static;\n  width: auto; }\n";
	
	var css = function () {
	  var dfp = DEFAULT_FAMILY_PREFIX;
	  var drc = DEFAULT_REPLACEMENT_CLASS;
	  var fp = config$1.familyPrefix;
	  var rc = config$1.replacementClass;
	  var s = baseStyles;
	
	  if (fp !== dfp || rc !== drc) {
	    var dPatt = new RegExp('\\.' + dfp + '\\-', 'g');
	    var rPatt = new RegExp('\\.' + drc, 'g');
	
	    s = s.replace(dPatt, '.' + fp + '-').replace(rPatt, '.' + rc);
	  }
	
	  return s;
	};
	
	function define(prefix, icons) {
	  var normalized = Object.keys(icons).reduce(function (acc, iconName) {
	    var icon = icons[iconName];
	    var expanded = !!icon.icon;
	
	    if (expanded) {
	      acc[icon.iconName] = icon.icon;
	    } else {
	      acc[iconName] = icon;
	    }
	    return acc;
	  }, {});
	
	  if (typeof namespace.hooks.addPack === 'function') {
	    namespace.hooks.addPack(prefix, normalized);
	  } else {
	    namespace.styles[prefix] = _extends({}, namespace.styles[prefix] || {}, normalized);
	  }
	
	  /**
	   * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
	   * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
	   * for `fas` so we'll easy the upgrade process for our users by automatically defining
	   * this as well.
	   */
	  if (prefix === 'fas') {
	    define('fa', icons);
	  }
	}
	
	var Library = function () {
	  function Library() {
	    classCallCheck(this, Library);
	
	    this.definitions = {};
	  }
	
	  createClass(Library, [{
	    key: 'add',
	    value: function add() {
	      var _this = this;
	
	      for (var _len = arguments.length, definitions = Array(_len), _key = 0; _key < _len; _key++) {
	        definitions[_key] = arguments[_key];
	      }
	
	      var additions = definitions.reduce(this._pullDefinitions, {});
	
	      Object.keys(additions).forEach(function (key) {
	        _this.definitions[key] = _extends({}, _this.definitions[key] || {}, additions[key]);
	        define(key, additions[key]);
	      });
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.definitions = {};
	    }
	  }, {
	    key: '_pullDefinitions',
	    value: function _pullDefinitions(additions, definition) {
	      var normalized = definition.prefix && definition.iconName && definition.icon ? { 0: definition } : definition;
	
	      Object.keys(normalized).map(function (key) {
	        var _normalized$key = normalized[key],
	            prefix = _normalized$key.prefix,
	            iconName = _normalized$key.iconName,
	            icon = _normalized$key.icon;
	
	
	        if (!additions[prefix]) additions[prefix] = {};
	
	        additions[prefix][iconName] = icon;
	      });
	
	      return additions;
	    }
	  }]);
	  return Library;
	}();
	
	function prepIcon(icon) {
	  var width = icon[0];
	  var height = icon[1];
	  var vectorData = icon.slice(4);
	
	  return {
	    found: true,
	    width: width,
	    height: height,
	    icon: { tag: 'path', attributes: { fill: 'currentColor', d: vectorData[0] } }
	  };
	}
	
	var _cssInserted = false;
	
	function ensureCss() {
	  if (!config$1.autoAddCss) {
	    return;
	  }
	
	  if (!_cssInserted) {
	    insertCss(css());
	  }
	
	  _cssInserted = true;
	}
	
	function apiObject(val, abstractCreator) {
	  Object.defineProperty(val, 'abstract', {
	    get: abstractCreator
	  });
	
	  Object.defineProperty(val, 'html', {
	    get: function get() {
	      return val.abstract.map(function (a) {
	        return toHtml(a);
	      });
	    }
	  });
	
	  Object.defineProperty(val, 'node', {
	    get: function get() {
	      if (!IS_DOM) return;
	
	      var container = DOCUMENT.createElement('div');
	      container.innerHTML = val.html;
	      return container.children;
	    }
	  });
	
	  return val;
	}
	
	function findIconDefinition(params) {
	  var _params$prefix = params.prefix,
	      prefix = _params$prefix === undefined ? 'fa' : _params$prefix,
	      iconName = params.iconName;
	
	
	  if (!iconName) return;
	
	  return iconFromMapping(library.definitions, prefix, iconName) || iconFromMapping(namespace.styles, prefix, iconName);
	}
	
	function resolveIcons(next) {
	  return function (maybeIconDefinition) {
	    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var iconDefinition = (maybeIconDefinition || {}).icon ? maybeIconDefinition : findIconDefinition(maybeIconDefinition || {});
	
	    var mask = params.mask;
	
	
	    if (mask) {
	      mask = (mask || {}).icon ? mask : findIconDefinition(mask || {});
	    }
	
	    return next(iconDefinition, _extends({}, params, { mask: mask }));
	  };
	}
	
	var library = new Library();
	
	var noAuto = function noAuto() {
	  auto(false);
	  disconnect();
	};
	
	var dom = {
	  i2svg: function i2svg() {
	    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    if (IS_DOM) {
	      ensureCss();
	
	      var _params$node = params.node,
	          node = _params$node === undefined ? DOCUMENT : _params$node,
	          _params$callback = params.callback,
	          callback = _params$callback === undefined ? function () {} : _params$callback;
	
	
	      if (config$1.searchPseudoElements) {
	        searchPseudoElements(node);
	      }
	
	      onTree(node, callback);
	    }
	  },
	
	  css: css,
	
	  insertCss: function insertCss$$1() {
	    insertCss(css());
	  }
	};
	
	var parse = {
	  transform: function transform(transformString) {
	    return parseTransformString(transformString);
	  }
	};
	
	var icon = resolveIcons(function (iconDefinition) {
	  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var _params$transform = params.transform,
	      transform = _params$transform === undefined ? meaninglessTransform : _params$transform,
	      _params$symbol = params.symbol,
	      symbol = _params$symbol === undefined ? false : _params$symbol,
	      _params$mask = params.mask,
	      mask = _params$mask === undefined ? null : _params$mask,
	      _params$title = params.title,
	      title = _params$title === undefined ? null : _params$title,
	      _params$classes = params.classes,
	      classes = _params$classes === undefined ? [] : _params$classes,
	      _params$attributes = params.attributes,
	      attributes = _params$attributes === undefined ? {} : _params$attributes,
	      _params$styles = params.styles,
	      styles = _params$styles === undefined ? {} : _params$styles;
	
	
	  if (!iconDefinition) return;
	
	  var prefix = iconDefinition.prefix,
	      iconName = iconDefinition.iconName,
	      icon = iconDefinition.icon;
	
	
	  return apiObject(_extends({ type: 'icon' }, iconDefinition), function () {
	    ensureCss();
	
	    if (config$1.autoA11y) {
	      if (title) {
	        attributes['aria-labelledby'] = config$1.replacementClass + '-title-' + nextUniqueId();
	      } else {
	        attributes['aria-hidden'] = 'true';
	      }
	    }
	
	    return makeInlineSvgAbstract({
	      icons: {
	        main: prepIcon(icon),
	        mask: mask ? prepIcon(mask.icon) : { found: false, width: null, height: null, icon: {} }
	      },
	      prefix: prefix,
	      iconName: iconName,
	      transform: _extends({}, meaninglessTransform, transform),
	      symbol: symbol,
	      title: title,
	      extra: {
	        attributes: attributes,
	        styles: styles,
	        classes: classes
	      }
	    });
	  });
	});
	
	var text = function text(content) {
	  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var _params$transform2 = params.transform,
	      transform = _params$transform2 === undefined ? meaninglessTransform : _params$transform2,
	      _params$title2 = params.title,
	      title = _params$title2 === undefined ? null : _params$title2,
	      _params$classes2 = params.classes,
	      classes = _params$classes2 === undefined ? [] : _params$classes2,
	      _params$attributes2 = params.attributes,
	      attributes = _params$attributes2 === undefined ? {} : _params$attributes2,
	      _params$styles2 = params.styles,
	      styles = _params$styles2 === undefined ? {} : _params$styles2;
	
	
	  return apiObject({ type: 'text', content: content }, function () {
	    ensureCss();
	
	    return makeLayersTextAbstract({
	      content: content,
	      transform: _extends({}, meaninglessTransform, transform),
	      title: title,
	      extra: {
	        attributes: attributes,
	        styles: styles,
	        classes: [config$1.familyPrefix + '-layers-text'].concat(toConsumableArray(classes))
	      }
	    });
	  });
	};
	
	var layer = function layer(assembler) {
	  return apiObject({ type: 'layer' }, function () {
	    ensureCss();
	
	    var children = [];
	
	    assembler(function (args) {
	      Array.isArray(args) ? args.map(function (a) {
	        children = children.concat(a.abstract);
	      }) : children = children.concat(args.abstract);
	    });
	
	    return [{
	      tag: 'span',
	      attributes: { class: config$1.familyPrefix + '-layers' },
	      children: children
	    }];
	  });
	};
	
	var api$1 = {
	  noAuto: noAuto,
	  dom: dom,
	  library: library,
	  parse: parse,
	  findIconDefinition: findIconDefinition,
	  icon: icon,
	  text: text,
	  layer: layer
	};
	
	var autoReplace = function autoReplace() {
	  if (IS_DOM && config$1.autoReplaceSvg) api$1.dom.i2svg({ node: DOCUMENT });
	};
	
	function bootstrap() {
	  if (IS_BROWSER) {
	    if (!WINDOW.FontAwesome) {
	      WINDOW.FontAwesome = api$1;
	    }
	
	    domready(function () {
	      if (Object.keys(namespace.styles).length > 0) {
	        autoReplace();
	      }
	
	      if (config$1.observeMutations && typeof MutationObserver === 'function') {
	        observe({
	          treeCallback: onTree,
	          nodeCallback: onNode,
	          pseudoElementsCallback: searchPseudoElements
	        });
	      }
	    });
	  }
	
	  namespace.hooks = _extends({}, namespace.hooks, {
	
	    addPack: function addPack(prefix, icons) {
	      namespace.styles[prefix] = _extends({}, namespace.styles[prefix] || {}, icons);
	
	      build();
	      autoReplace();
	    },
	
	    addShims: function addShims(shims) {
	      var _namespace$shims;
	
	      (_namespace$shims = namespace.shims).push.apply(_namespace$shims, toConsumableArray(shims));
	
	      build();
	      autoReplace();
	    }
	  });
	}
	
	Object.defineProperty(api$1, 'config', {
	  get: function get() {
	    return config$1;
	  },
	
	  set: function set(newConfig) {
	    update(newConfig);
	  }
	});
	
	if (IS_DOM) bunker(bootstrap);
	
	var config = api$1.config;
	
	exports.config = config;
	exports['default'] = api$1;
	exports.icon = icon;
	exports.noAuto = noAuto;
	exports.layer = layer;
	exports.text = text;
	exports.library = library;
	exports.dom = dom;
	exports.parse = parse;
	exports.findIconDefinition = findIconDefinition;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),

/***/ 329:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
		 true ? module.exports = factory(__webpack_require__(328), __webpack_require__(3), __webpack_require__(2)) :
		typeof define === 'function' && define.amd ? define(['@fortawesome/fontawesome', 'prop-types', 'react'], factory) :
		(global['react-fontawesome'] = factory(global.FontAwesome,global.PropTypes,global.React));
	}(this, (function (fontawesome,PropTypes,React) { 'use strict';
	
	fontawesome = fontawesome && fontawesome.hasOwnProperty('default') ? fontawesome['default'] : fontawesome;
	PropTypes = PropTypes && PropTypes.hasOwnProperty('default') ? PropTypes['default'] : PropTypes;
	React = React && React.hasOwnProperty('default') ? React['default'] : React;
	
	var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
	
	
	
	
	
	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}
	
	var humps = createCommonjsModule(function (module) {
	// =========
	// = humps =
	// =========
	// Underscore-to-camelCase converter (and vice versa)
	// for strings and object keys
	
	// humps is copyright © 2012+ Dom Christie
	// Released under the MIT license.
	
	
	(function(global) {
	
	  var _processKeys = function(convert, obj, options) {
	    if(!_isObject(obj) || _isDate(obj) || _isRegExp(obj) || _isBoolean(obj) || _isFunction(obj)) {
	      return obj;
	    }
	
	    var output,
	        i = 0,
	        l = 0;
	
	    if(_isArray(obj)) {
	      output = [];
	      for(l=obj.length; i<l; i++) {
	        output.push(_processKeys(convert, obj[i], options));
	      }
	    }
	    else {
	      output = {};
	      for(var key in obj) {
	        if(Object.prototype.hasOwnProperty.call(obj, key)) {
	          output[convert(key, options)] = _processKeys(convert, obj[key], options);
	        }
	      }
	    }
	    return output;
	  };
	
	  // String conversion methods
	
	  var separateWords = function(string, options) {
	    options = options || {};
	    var separator = options.separator || '_';
	    var split = options.split || /(?=[A-Z])/;
	
	    return string.split(split).join(separator);
	  };
	
	  var camelize = function(string) {
	    if (_isNumerical(string)) {
	      return string;
	    }
	    string = string.replace(/[\-_\s]+(.)?/g, function(match, chr) {
	      return chr ? chr.toUpperCase() : '';
	    });
	    // Ensure 1st char is always lowercase
	    return string.substr(0, 1).toLowerCase() + string.substr(1);
	  };
	
	  var pascalize = function(string) {
	    var camelized = camelize(string);
	    // Ensure 1st char is always uppercase
	    return camelized.substr(0, 1).toUpperCase() + camelized.substr(1);
	  };
	
	  var decamelize = function(string, options) {
	    return separateWords(string, options).toLowerCase();
	  };
	
	  // Utilities
	  // Taken from Underscore.js
	
	  var toString = Object.prototype.toString;
	
	  var _isFunction = function(obj) {
	    return typeof(obj) === 'function';
	  };
	  var _isObject = function(obj) {
	    return obj === Object(obj);
	  };
	  var _isArray = function(obj) {
	    return toString.call(obj) == '[object Array]';
	  };
	  var _isDate = function(obj) {
	    return toString.call(obj) == '[object Date]';
	  };
	  var _isRegExp = function(obj) {
	    return toString.call(obj) == '[object RegExp]';
	  };
	  var _isBoolean = function(obj) {
	    return toString.call(obj) == '[object Boolean]';
	  };
	
	  // Performant way to determine if obj coerces to a number
	  var _isNumerical = function(obj) {
	    obj = obj - 0;
	    return obj === obj;
	  };
	
	  // Sets up function which handles processing keys
	  // allowing the convert function to be modified by a callback
	  var _processor = function(convert, options) {
	    var callback = options && 'process' in options ? options.process : options;
	
	    if(typeof(callback) !== 'function') {
	      return convert;
	    }
	
	    return function(string, options) {
	      return callback(string, convert, options);
	    }
	  };
	
	  var humps = {
	    camelize: camelize,
	    decamelize: decamelize,
	    pascalize: pascalize,
	    depascalize: decamelize,
	    camelizeKeys: function(object, options) {
	      return _processKeys(_processor(camelize, options), object);
	    },
	    decamelizeKeys: function(object, options) {
	      return _processKeys(_processor(decamelize, options), object, options);
	    },
	    pascalizeKeys: function(object, options) {
	      return _processKeys(_processor(pascalize, options), object);
	    },
	    depascalizeKeys: function () {
	      return this.decamelizeKeys.apply(this, arguments);
	    }
	  };
	
	  if (false) {
	    undefined(humps);
	  } else if ('object' !== 'undefined' && module.exports) {
	    module.exports = humps;
	  } else {
	    global.humps = humps;
	  }
	
	})(commonjsGlobal);
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	};
	
	
	
	
	
	var asyncGenerator = function () {
	  function AwaitValue(value) {
	    this.value = value;
	  }
	
	  function AsyncGenerator(gen) {
	    var front, back;
	
	    function send(key, arg) {
	      return new Promise(function (resolve, reject) {
	        var request = {
	          key: key,
	          arg: arg,
	          resolve: resolve,
	          reject: reject,
	          next: null
	        };
	
	        if (back) {
	          back = back.next = request;
	        } else {
	          front = back = request;
	          resume(key, arg);
	        }
	      });
	    }
	
	    function resume(key, arg) {
	      try {
	        var result = gen[key](arg);
	        var value = result.value;
	
	        if (value instanceof AwaitValue) {
	          Promise.resolve(value.value).then(function (arg) {
	            resume("next", arg);
	          }, function (arg) {
	            resume("throw", arg);
	          });
	        } else {
	          settle(result.done ? "return" : "normal", result.value);
	        }
	      } catch (err) {
	        settle("throw", err);
	      }
	    }
	
	    function settle(type, value) {
	      switch (type) {
	        case "return":
	          front.resolve({
	            value: value,
	            done: true
	          });
	          break;
	
	        case "throw":
	          front.reject(value);
	          break;
	
	        default:
	          front.resolve({
	            value: value,
	            done: false
	          });
	          break;
	      }
	
	      front = front.next;
	
	      if (front) {
	        resume(front.key, front.arg);
	      } else {
	        back = null;
	      }
	    }
	
	    this._invoke = send;
	
	    if (typeof gen.return !== "function") {
	      this.return = undefined;
	    }
	  }
	
	  if (typeof Symbol === "function" && Symbol.asyncIterator) {
	    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
	      return this;
	    };
	  }
	
	  AsyncGenerator.prototype.next = function (arg) {
	    return this._invoke("next", arg);
	  };
	
	  AsyncGenerator.prototype.throw = function (arg) {
	    return this._invoke("throw", arg);
	  };
	
	  AsyncGenerator.prototype.return = function (arg) {
	    return this._invoke("return", arg);
	  };
	
	  return {
	    wrap: function (fn) {
	      return function () {
	        return new AsyncGenerator(fn.apply(this, arguments));
	      };
	    },
	    await: function (value) {
	      return new AwaitValue(value);
	    }
	  };
	}();
	
	
	
	
	
	
	
	
	
	
	
	
	
	var defineProperty = function (obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	
	
	
	
	
	
	
	
	
	
	
	
	var objectWithoutProperties = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var toConsumableArray = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
	
	    return arr2;
	  } else {
	    return Array.from(arr);
	  }
	};
	
	function capitalize(val) {
	  return val.charAt(0).toUpperCase() + val.slice(1);
	}
	
	function styleToObject(style) {
	  return style.split(';').map(function (s) {
	    return s.trim();
	  }).filter(function (s) {
	    return s;
	  }).reduce(function (acc, pair) {
	    var i = pair.indexOf(':');
	    var prop = humps.camelize(pair.slice(0, i));
	    var value = pair.slice(i + 1).trim();
	
	    prop.startsWith('webkit') ? acc[capitalize(prop)] = value : acc[prop] = value;
	
	    return acc;
	  }, {});
	}
	
	function convert(createElement, element) {
	  var extraProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  var children = (element.children || []).map(convert.bind(null, createElement));
	
	  var mixins = Object.keys(element.attributes || {}).reduce(function (acc, key) {
	    var val = element.attributes[key];
	
	    switch (key) {
	      case 'class':
	        acc.attrs['className'] = val;
	        delete element.attributes['class'];
	        break;
	      case 'style':
	        acc.attrs['style'] = styleToObject(val);
	        break;
	      default:
	        if (key.indexOf('aria-') === 0 || key.indexOf('data-') === 0) {
	          acc.attrs[key.toLowerCase()] = val;
	        } else {
	          acc.attrs[humps.camelize(key)] = val;
	        }
	    }
	
	    return acc;
	  }, { attrs: {} });
	
	  var _extraProps$style = extraProps.style,
	      existingStyle = _extraProps$style === undefined ? {} : _extraProps$style,
	      remaining = objectWithoutProperties(extraProps, ['style']);
	
	
	  mixins.attrs['style'] = _extends({}, mixins.attrs['style'], existingStyle);
	
	  return createElement.apply(undefined, [element.tag, _extends({}, mixins.attrs, remaining)].concat(toConsumableArray(children)));
	}
	
	var PRODUCTION = false;
	
	try {
	  PRODUCTION = ("production") === 'production';
	} catch (e) {}
	
	var log = function () {
	  if (!PRODUCTION && console && typeof console.error === 'function') {
	    var _console;
	
	    (_console = console).error.apply(_console, arguments);
	  }
	};
	
	function objectWithKey(key, value) {
	  return Array.isArray(value) && value.length > 0 || !Array.isArray(value) && value ? defineProperty({}, key, value) : {};
	}
	
	function classList(props) {
	  var _classes;
	
	  var classes = (_classes = {
	    'fa-spin': props.spin,
	    'fa-pulse': props.pulse,
	    'fa-fw': props.fixedWidth,
	    'fa-border': props.border,
	    'fa-li': props.listItem,
	    'fa-flip-horizontal': props.flip === 'horizontal' || props.flip === 'both',
	    'fa-flip-vertical': props.flip === 'vertical' || props.flip === 'both'
	  }, defineProperty(_classes, 'fa-' + props.size, props.size !== null), defineProperty(_classes, 'fa-rotate-' + props.rotation, props.rotation !== null), defineProperty(_classes, 'fa-pull-' + props.pull, props.pull !== null), _classes);
	
	  return Object.keys(classes).map(function (key) {
	    return classes[key] ? key : null;
	  }).filter(function (key) {
	    return key;
	  });
	}
	
	function normalizeIconArgs(icon) {
	  if (icon === null) {
	    return null;
	  }
	
	  if ((typeof icon === 'undefined' ? 'undefined' : _typeof(icon)) === 'object' && icon.prefix && icon.iconName) {
	    return icon;
	  }
	
	  if (Array.isArray(icon) && icon.length === 2) {
	    return { prefix: icon[0], iconName: icon[1] };
	  }
	
	  if (typeof icon === 'string') {
	    return { prefix: 'fas', iconName: icon };
	  }
	}
	
	function FontAwesomeIcon$1(props) {
	  var iconArgs = props.icon,
	      maskArgs = props.mask,
	      symbol = props.symbol,
	      className = props.className;
	
	
	  var icon = normalizeIconArgs(iconArgs);
	  var classes = objectWithKey('classes', [].concat(toConsumableArray(classList(props)), toConsumableArray(className.split(' '))));
	  var transform = objectWithKey('transform', typeof props.transform === 'string' ? fontawesome.parse.transform(props.transform) : props.transform);
	  var mask = objectWithKey('mask', normalizeIconArgs(maskArgs));
	
	  var renderedIcon = fontawesome.icon(icon, _extends({}, classes, transform, mask, {
	    symbol: symbol
	  }));
	
	  if (!renderedIcon) {
	    log('Could not find icon', icon);
	    return null;
	  }
	
	  var abstract = renderedIcon.abstract;
	
	  var convertCurry = convert.bind(null, React.createElement);
	  var extraProps = {};
	
	  Object.keys(props).forEach(function (key) {
	    if (!FontAwesomeIcon$1.defaultProps.hasOwnProperty(key)) extraProps[key] = props[key];
	  });
	
	  return convertCurry(abstract[0], extraProps);
	}
	
	FontAwesomeIcon$1.propTypes = {
	  border: PropTypes.bool,
	
	  className: PropTypes.string,
	
	  mask: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.string]),
	
	  fixedWidth: PropTypes.bool,
	
	  flip: PropTypes.oneOf(['horizontal', 'vertical', 'both']),
	
	  icon: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.string]),
	
	  listItem: PropTypes.bool,
	
	  pull: PropTypes.oneOf(['right', 'left']),
	
	  pulse: PropTypes.bool,
	
	  name: PropTypes.string,
	
	  rotation: PropTypes.oneOf([90, 180, 270]),
	
	  size: PropTypes.oneOf(['lg', 'xs', 'sm', '1x', '2x', '3x', '4x', '5x', '6x', '7x', '8x', '9x', '10x']),
	
	  spin: PropTypes.bool,
	
	  symbol: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
	
	  transform: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
	};
	
	FontAwesomeIcon$1.defaultProps = {
	  border: false,
	  className: '',
	  mask: null,
	  fixedWidth: false,
	  flip: null,
	  icon: null,
	  listItem: false,
	  pull: null,
	  pulse: false,
	  name: '',
	  rotation: null,
	  size: null,
	  spin: false,
	  symbol: false,
	  transform: null
	};
	
	fontawesome.noAuto();
	
	return FontAwesomeIcon$1;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 225:
/***/ (function(module, exports) {

	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_SAFE_INTEGER = 9007199254740991,
	    MAX_INTEGER = 1.7976931348623157e+308,
	    NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeCeil = Math.ceil,
	    nativeMax = Math.max;
	
	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;
	
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = end > length ? length : end;
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;
	
	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	/**
	 * Creates an array of elements split into groups the length of `size`.
	 * If `array` can't be split evenly, the final chunk will be the remaining
	 * elements.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Array
	 * @param {Array} array The array to process.
	 * @param {number} [size=1] The length of each chunk
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Array} Returns the new array of chunks.
	 * @example
	 *
	 * _.chunk(['a', 'b', 'c', 'd'], 2);
	 * // => [['a', 'b'], ['c', 'd']]
	 *
	 * _.chunk(['a', 'b', 'c', 'd'], 3);
	 * // => [['a', 'b', 'c'], ['d']]
	 */
	function chunk(array, size, guard) {
	  if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	    size = 1;
	  } else {
	    size = nativeMax(toInteger(size), 0);
	  }
	  var length = array ? array.length : 0;
	  if (!length || size < 1) {
	    return [];
	  }
	  var index = 0,
	      resIndex = 0,
	      result = Array(nativeCeil(length / size));
	
	  while (index < length) {
	    result[resIndex++] = baseSlice(array, index, (index += size));
	  }
	  return result;
	}
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = chunk;


/***/ }),

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used to compose bitmasks for comparison styles. */
	var UNORDERED_COMPARE_FLAG = 1,
	    PARTIAL_COMPARE_FLAG = 2;
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/,
	    reLeadingDot = /^\./,
	    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array ? array.length : 0,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	/**
	 * The base implementation of `_.sortBy` which uses `comparer` to define the
	 * sort order of `array` and replaces criteria objects with their corresponding
	 * values.
	 *
	 * @private
	 * @param {Array} array The array to sort.
	 * @param {Function} comparer The function to define sort order.
	 * @returns {Array} Returns `array`.
	 */
	function baseSortBy(array, comparer) {
	  var length = array.length;
	
	  array.sort(comparer);
	  while (length--) {
	    array[length] = array[length].value;
	  }
	  return array;
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Symbol = root.Symbol,
	    Uint8Array = root.Uint8Array,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView'),
	    Map = getNative(root, 'Map'),
	    Promise = getNative(root, 'Promise'),
	    Set = getNative(root, 'Set'),
	    WeakMap = getNative(root, 'WeakMap'),
	    nativeCreate = getNative(Object, 'create');
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values ? values.length : 0;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  this.__data__ = new ListCache(entries);
	}
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	}
	
	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  return this.__data__['delete'](key);
	}
	
	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var cache = this.__data__;
	  if (cache instanceof ListCache) {
	    var pairs = cache.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      return this;
	    }
	    cache = this.__data__ = new MapCache(pairs);
	  }
	  cache.set(key, value);
	  return this;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  // Safari 9 makes `arguments.length` enumerable in strict mode.
	  var result = (isArray(value) || isArguments(value))
	    ? baseTimes(value.length, String)
	    : [];
	
	  var length = result.length,
	      skipIndexes = !!length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = isKey(path, object) ? [path] : castPath(path);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	/**
	 * The base implementation of `getTag`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  return objectToString.call(value);
	}
	
	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {boolean} [bitmask] The bitmask of comparison flags.
	 *  The bitmask may be composed of the following flags:
	 *     1 - Unordered comparison
	 *     2 - Partial comparison
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, customizer, bitmask, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
	}
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = arrayTag,
	      othTag = arrayTag;
	
	  if (!objIsArr) {
	    objTag = getTag(object);
	    objTag = objTag == argsTag ? objectTag : objTag;
	  }
	  if (!othIsArr) {
	    othTag = getTag(other);
	    othTag = othTag == argsTag ? objectTag : othTag;
	  }
	  var objIsObj = objTag == objectTag && !isHostObject(object),
	      othIsObj = othTag == objectTag && !isHostObject(other),
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, equalFunc, customizer, bitmask, stack)
	      : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
	  }
	  if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
	}
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
	}
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.map` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap(collection, iteratee) {
	  var index = -1,
	      result = isArrayLike(collection) ? Array(collection.length) : [];
	
	  baseEach(collection, function(value, key, collection) {
	    result[++index] = iteratee(value, key, collection);
	  });
	  return result;
	}
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
	  };
	}
	
	/**
	 * The base implementation of `_.orderBy` without param guards.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	 * @param {string[]} orders The sort orders of `iteratees`.
	 * @returns {Array} Returns the new sorted array.
	 */
	function baseOrderBy(collection, iteratees, orders) {
	  var index = -1;
	  iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(baseIteratee));
	
	  var result = baseMap(collection, function(value, key, collection) {
	    var criteria = arrayMap(iteratees, function(iteratee) {
	      return iteratee(value);
	    });
	    return { 'criteria': criteria, 'index': ++index, 'value': value };
	  });
	
	  return baseSortBy(result, function(object, other) {
	    return compareMultiple(object, other, orders);
	  });
	}
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value) {
	  return isArray(value) ? value : stringToPath(value);
	}
	
	/**
	 * Compares values to sort them in ascending order.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {number} Returns the sort order indicator for `value`.
	 */
	function compareAscending(value, other) {
	  if (value !== other) {
	    var valIsDefined = value !== undefined,
	        valIsNull = value === null,
	        valIsReflexive = value === value,
	        valIsSymbol = isSymbol(value);
	
	    var othIsDefined = other !== undefined,
	        othIsNull = other === null,
	        othIsReflexive = other === other,
	        othIsSymbol = isSymbol(other);
	
	    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	        (valIsNull && othIsDefined && othIsReflexive) ||
	        (!valIsDefined && othIsReflexive) ||
	        !valIsReflexive) {
	      return 1;
	    }
	    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	        (othIsNull && valIsDefined && valIsReflexive) ||
	        (!othIsDefined && valIsReflexive) ||
	        !othIsReflexive) {
	      return -1;
	    }
	  }
	  return 0;
	}
	
	/**
	 * Used by `_.orderBy` to compare multiple properties of a value to another
	 * and stable sort them.
	 *
	 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	 * specify an order of "desc" for descending or "asc" for ascending sort order
	 * of corresponding values.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {boolean[]|string[]} orders The order to sort by for each property.
	 * @returns {number} Returns the sort order indicator for `object`.
	 */
	function compareMultiple(object, other, orders) {
	  var index = -1,
	      objCriteria = object.criteria,
	      othCriteria = other.criteria,
	      length = objCriteria.length,
	      ordersLength = orders.length;
	
	  while (++index < length) {
	    var result = compareAscending(objCriteria[index], othCriteria[index]);
	    if (result) {
	      if (index >= ordersLength) {
	        return result;
	      }
	      var order = orders[index];
	      return result * (order == 'desc' ? -1 : 1);
	    }
	  }
	  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	  // that causes it, under certain circumstances, to provide the same value for
	  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	  // for more details.
	  //
	  // This also ensures a stable sort in V8 and other engines.
	  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	  return object.index - other.index;
	}
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
	  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & UNORDERED_COMPARE_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!seen.has(othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
	              return seen.add(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, customizer, bitmask, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= UNORDERED_COMPARE_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
	  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	      objProps = keys(object),
	      objLength = objProps.length,
	      othProps = keys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11,
	// for data views in Edge < 14, and promises in Node.js.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = objectToString.call(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : undefined;
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = isKey(path, object) ? [path] : castPath(path);
	
	  var result,
	      index = -1,
	      length = path.length;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result) {
	    return result;
	  }
	  var length = object ? object.length : 0;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoize(function(string) {
	  string = toString(string);
	
	  var result = [];
	  if (reLeadingDot.test(string)) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * This method is like `_.sortBy` except that it allows specifying the sort
	 * orders of the iteratees to sort by. If `orders` is unspecified, all values
	 * are sorted in ascending order. Otherwise, specify an order of "desc" for
	 * descending or "asc" for ascending sort order of corresponding values.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	 *  The iteratees to sort by.
	 * @param {string[]} [orders] The sort orders of `iteratees`.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	 * @returns {Array} Returns the new sorted array.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'fred',   'age': 48 },
	 *   { 'user': 'barney', 'age': 34 },
	 *   { 'user': 'fred',   'age': 40 },
	 *   { 'user': 'barney', 'age': 36 }
	 * ];
	 *
	 * // Sort by `user` in ascending order and by `age` in descending order.
	 * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	 */
	function orderBy(collection, iteratees, orders, guard) {
	  if (collection == null) {
	    return [];
	  }
	  if (!isArray(iteratees)) {
	    iteratees = iteratees == null ? [] : [iteratees];
	  }
	  orders = guard ? undefined : orders;
	  if (!isArray(orders)) {
	    orders = orders == null ? [] : [orders];
	  }
	  return baseOrderBy(collection, iteratees, orders);
	}
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result);
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Assign cache to `_.memoize`.
	memoize.Cache = MapCache;
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = orderBy;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(24)(module)))

/***/ }),

/***/ 131:
/***/ (function(module, exports) {

	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array ? array.length : 0,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.values` and `_.valuesIn` which creates an
	 * array of `object` property values corresponding to the property names
	 * of `props`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} props The property names to get values for.
	 * @returns {Object} Returns the array of property values.
	 */
	function baseValues(object, props) {
	  return arrayMap(props, function(key) {
	    return object[key];
	  });
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  // Safari 9 makes `arguments.length` enumerable in strict mode.
	  var result = (isArray(value) || isArguments(value))
	    ? baseTimes(value.length, String)
	    : [];
	
	  var length = result.length,
	      skipIndexes = !!length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	/**
	 * Creates an array of the own enumerable string keyed property values of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property values.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.values(new Foo);
	 * // => [1, 2] (iteration order is not guaranteed)
	 *
	 * _.values('hi');
	 * // => ['h', 'i']
	 */
	function values(object) {
	  return object ? baseValues(object, keys(object)) : [];
	}
	
	module.exports = values;


/***/ }),

/***/ 24:
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(13);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _buttonModule = __webpack_require__(71);
	
	var _buttonModule2 = _interopRequireDefault(_buttonModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var buttonClasses = function buttonClasses(props) {
	  var className = props.className,
	      size = props.size,
	      inverted = props.inverted,
	      isOutlined = props.isOutlined;
	
	  return (0, _classnames2.default)('button', 'is-primary', 'is-uppercase', 'is-' + size, _buttonModule2.default.Button, className, {
	    'is-inverted': inverted,
	    'is-outlined': isOutlined
	  });
	};
	
	var Button = function Button(props) {
	  var href = props.href,
	      children = props.children,
	      onClick = props.onClick;
	
	  var clickHandler = void 0;
	
	  if (onClick) {
	    clickHandler = function clickHandler(e) {
	      e.preventDefault();
	      onClick();
	    };
	  }
	
	  var anchorProps = {
	    className: buttonClasses(props),
	    href: href
	  };
	
	  if (/http/.test(href)) {
	    return _react2.default.createElement(
	      'a',
	      anchorProps,
	      children
	    );
	  }
	
	  anchorProps.to = href;
	
	  if (clickHandler) {
	    anchorProps.onClick = clickHandler;
	  }
	
	  return _react2.default.createElement(
	    _gatsbyLink2.default,
	    anchorProps,
	    children
	  );
	};
	
	Button.propTypes = {
	  children: _propTypes2.default.node.isRequired,
	  className: _propTypes2.default.string, // eslint-disable-line react/no-unused-prop-types
	  href: _propTypes2.default.string,
	  inverted: _propTypes2.default.bool, // eslint-disable-line react/no-unused-prop-types
	  isOutlined: _propTypes2.default.bool, // eslint-disable-line react/no-unused-prop-types
	  onClick: _propTypes2.default.func,
	  size: _propTypes2.default.string // eslint-disable-line react/no-unused-prop-types
	};
	
	Button.defaultProps = {
	  className: '',
	  href: '#',
	  inverted: false,
	  size: 'small',
	  isOutlined: true
	};
	
	exports.default = Button;
	module.exports = exports['default'];

/***/ }),

/***/ 264:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _listHeaderModule = __webpack_require__(450);
	
	var _listHeaderModule2 = _interopRequireDefault(_listHeaderModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListHeader = function ListHeader(_ref) {
	  var href = _ref.href,
	      text = _ref.text;
	  return _react2.default.createElement(
	    'div',
	    { className: _listHeaderModule2.default.ListHeader },
	    _react2.default.createElement(
	      'h2',
	      { className: 'is-size-3' },
	      text
	    ),
	    _react2.default.createElement(
	      'a',
	      { className: (0, _classnames2.default)('is-size-7', _listHeaderModule2.default.ListHeader__link), href: href },
	      'View all'
	    )
	  );
	};
	
	ListHeader.propTypes = {
	  href: _propTypes2.default.string.isRequired,
	  text: _propTypes2.default.string.isRequired
	};
	
	exports.default = ListHeader;
	module.exports = exports['default'];

/***/ }),

/***/ 339:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ArticleListItem = __webpack_require__(340);
	
	var _ArticleListItem2 = _interopRequireDefault(_ArticleListItem);
	
	var _ListHeader = __webpack_require__(264);
	
	var _ListHeader2 = _interopRequireDefault(_ListHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ArticleList = function ArticleList(_ref) {
	  var articles = _ref.articles;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_ListHeader2.default, { href: '/article/77-welcome-to-teamgantt', text: 'Articles' }),
	    _react2.default.createElement(
	      'ul',
	      null,
	      articles.map(function (article) {
	        return _react2.default.createElement(
	          'li',
	          { key: article.id },
	          _react2.default.createElement(_ArticleListItem2.default, { article: article })
	        );
	      })
	    )
	  );
	};
	
	ArticleList.propTypes = {
	  articles: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    id: _propTypes2.default.string.isRequired,
	    name: _propTypes2.default.string.isRequired
	  }).isRequired).isRequired
	};
	
	exports.default = ArticleList;
	module.exports = exports['default'];

/***/ }),

/***/ 340:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFontawesome = __webpack_require__(329);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _faFileAlt = __webpack_require__(327);
	
	var _faFileAlt2 = _interopRequireDefault(_faFileAlt);
	
	var _articleListModule = __webpack_require__(449);
	
	var _articleListModule2 = _interopRequireDefault(_articleListModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ArticleListItem = function ArticleListItem(_ref) {
	  var article = _ref.article;
	  return _react2.default.createElement(
	    'a',
	    {
	      className: (0, _classnames2.default)(_articleListModule2.default.ArticleListItem, 'is-size-5', 'has-text-grey-darker'),
	      href: '/article/' + article.number + '-' + article.slug
	    },
	    _react2.default.createElement(_reactFontawesome2.default, {
	      className: _articleListModule2.default.ArticleListItem__icon,
	      icon: _faFileAlt2.default
	    }),
	    article.name
	  );
	};
	
	ArticleListItem.propTypes = {
	  article: _propTypes2.default.shape({
	    id: _propTypes2.default.string.isRequired,
	    number: _propTypes2.default.number.isRequired,
	    name: _propTypes2.default.string.isRequired,
	    slug: _propTypes2.default.string.isRequired
	  }).isRequired
	};
	
	exports.default = ArticleListItem;
	module.exports = exports['default'];

/***/ }),

/***/ 449:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"ArticleListItem":"src-components-articles----article-list-module---ArticleListItem---1a426","ArticleListItem__icon":"src-components-articles----article-list-module---ArticleListItem__icon---15KAg","spinAround":"src-components-articles----article-list-module---spinAround---3j81c"};

/***/ }),

/***/ 71:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Button":"src-components----button-module---Button---3qeZK"};

/***/ }),

/***/ 341:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _guidesModule = __webpack_require__(288);
	
	var _guidesModule2 = _interopRequireDefault(_guidesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Guide = function Guide(_ref) {
	  var imgSrc = _ref.imgSrc,
	      imgAlt = _ref.imgAlt,
	      heading = _ref.heading,
	      href = _ref.href,
	      text = _ref.text;
	  return _react2.default.createElement(
	    'a',
	    { href: href, target: '_blank' },
	    _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('card', _guidesModule2.default.Guide) },
	      _react2.default.createElement(
	        'div',
	        { className: 'card-image' },
	        _react2.default.createElement(
	          'figure',
	          { className: 'image' },
	          _react2.default.createElement('img', { alt: imgAlt, className: _guidesModule2.default.Guide__img, src: imgSrc })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'card-content' },
	        _react2.default.createElement(
	          'p',
	          { className: (0, _classnames2.default)('has-text-black', _guidesModule2.default.Guide__heading) },
	          _react2.default.createElement(
	            'strong',
	            null,
	            heading
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          text
	        )
	      )
	    )
	  );
	};
	
	Guide.propTypes = {
	  heading: _propTypes2.default.string.isRequired,
	  href: _propTypes2.default.string.isRequired,
	  imgAlt: _propTypes2.default.string,
	  imgSrc: _propTypes2.default.string.isRequired,
	  text: _propTypes2.default.string.isRequired
	};
	
	Guide.defaultProps = {
	  imgAlt: ''
	};
	
	exports.default = Guide;
	module.exports = exports['default'];

/***/ }),

/***/ 288:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Guides__heading":"src-components-guides----guides-module---Guides__heading---VoZD4","Guide":"src-components-guides----guides-module---Guide---1bPF7","Guide__img":"src-components-guides----guides-module---Guide__img---zNEi0","Guide__heading":"src-components-guides----guides-module---Guide__heading---34PI2","spinAround":"src-components-guides----guides-module---spinAround---4f5x8"};

/***/ }),

/***/ 816:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/art-and-science@2x.5212664b.png";

/***/ }),

/***/ 817:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/project-management@2x.e6dd28dc.png";

/***/ }),

/***/ 818:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/project-planning@2x.0f07199c.png";

/***/ }),

/***/ 342:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Guide = __webpack_require__(341);
	
	var _Guide2 = _interopRequireDefault(_Guide);
	
	var _guidesModule = __webpack_require__(288);
	
	var _guidesModule2 = _interopRequireDefault(_guidesModule);
	
	var _projectManagement2x = __webpack_require__(817);
	
	var _projectManagement2x2 = _interopRequireDefault(_projectManagement2x);
	
	var _projectPlanning2x = __webpack_require__(818);
	
	var _projectPlanning2x2 = _interopRequireDefault(_projectPlanning2x);
	
	var _artAndScience2x = __webpack_require__(816);
	
	var _artAndScience2x2 = _interopRequireDefault(_artAndScience2x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Guides = function Guides() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h2',
	      { className: (0, _classnames2.default)('is-size-3', _guidesModule2.default.Guides__heading) },
	      'Guides'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'columns' },
	      _react2.default.createElement(
	        'div',
	        { className: 'column is-6' },
	        _react2.default.createElement(_Guide2.default, {
	          heading: 'The Art & Science of Leading Projects',
	          href: 'https://www.teamgantt.com/art-science-of-leading-projects',
	          imgSrc: _artAndScience2x2.default,
	          text: 'A free video course teaching you how to lead projects and manage teams'
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'column is-6' },
	        _react2.default.createElement(_Guide2.default, {
	          heading: 'The Guide to Project Management',
	          href: 'https://www.teamgantt.com/guide-to-project-management/',
	          imgSrc: _projectManagement2x2.default,
	          text: 'A how-to guide for project managers written by Brett Harned'
	        })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'columns' },
	      _react2.default.createElement(
	        'div',
	        { className: 'column is-6' },
	        _react2.default.createElement(_Guide2.default, {
	          heading: 'The Guide to Project Planning',
	          href: 'https://www.teamgantt.com/guide-to-project-planning',
	          imgSrc: _projectPlanning2x2.default,
	          text: 'A downloadable guide to help you create project plans and keep projects on track'
	        })
	      )
	    )
	  );
	};
	
	exports.default = Guides;
	module.exports = exports['default'];

/***/ }),

/***/ 450:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"ListHeader":"src-components----list-header-module---ListHeader---1CrUl","ListHeader__link":"src-components----list-header-module---ListHeader__link---2a4jQ"};

/***/ }),

/***/ 343:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Button = __webpack_require__(54);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _liveClassesModule = __webpack_require__(451);
	
	var _liveClassesModule2 = _interopRequireDefault(_liveClassesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LiveClasses = function LiveClasses(_ref) {
	  var className = _ref.className;
	  return _react2.default.createElement(
	    'section',
	    {
	      className: (0, _classnames2.default)(_liveClassesModule2.default.LiveClasses, 'section bg-party', className)
	    },
	    _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'has-text-white has-text-centered' },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)(_liveClassesModule2.default.LiveClasses__heading) },
	          _react2.default.createElement(
	            'h1',
	            { className: 'is-size-2' },
	            'Free Live Classes'
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'is-size-5' },
	            'Learn from the TeamGantt experts'
	          )
	        ),
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            className: (0, _classnames2.default)(_liveClassesModule2.default.LiveClasses__button),
	            href: 'https://www.teamgantt.com/classes',
	            inverted: true
	          },
	          'View Upcoming Classes'
	        )
	      )
	    )
	  );
	};
	
	LiveClasses.propTypes = {
	  className: _propTypes2.default.string
	};
	
	exports.default = LiveClasses;
	module.exports = exports['default'];

/***/ }),

/***/ 451:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"LiveClasses":"src-components-live-classes----live-classes-module---LiveClasses---EkKAU","LiveClasses__heading":"src-components-live-classes----live-classes-module---LiveClasses__heading---2aL-v","LiveClasses__experts":"src-components-live-classes----live-classes-module---LiveClasses__experts---15B1M","LiveClasses__expert":"src-components-live-classes----live-classes-module---LiveClasses__expert---b8R8c","LiveClasses__button":"src-components-live-classes----live-classes-module---LiveClasses__button---YD0AB","spinAround":"src-components-live-classes----live-classes-module---spinAround---u2R2c"};

/***/ }),

/***/ 349:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _iconModule = __webpack_require__(456);
	
	var _iconModule2 = _interopRequireDefault(_iconModule);
	
	var _xicn_getting_started = __webpack_require__(821);
	
	var _xicn_getting_started2 = _interopRequireDefault(_xicn_getting_started);
	
	var _xicn_collaborating = __webpack_require__(820);
	
	var _xicn_collaborating2 = _interopRequireDefault(_xicn_collaborating);
	
	var _xicn_project_planning_level_ = __webpack_require__(822);
	
	var _xicn_project_planning_level_2 = _interopRequireDefault(_xicn_project_planning_level_);
	
	var _xicnProjectPlanningLevelII = __webpack_require__(819);
	
	var _xicnProjectPlanningLevelII2 = _interopRequireDefault(_xicnProjectPlanningLevelII);
	
	var _xicn_top_videos = __webpack_require__(823);
	
	var _xicn_top_videos2 = _interopRequireDefault(_xicn_top_videos);
	
	var _icnTips2x = __webpack_require__(828);
	
	var _icnTips2x2 = _interopRequireDefault(_icnTips2x);
	
	var _icnAccount2x = __webpack_require__(824);
	
	var _icnAccount2x2 = _interopRequireDefault(_icnAccount2x);
	
	var _icnTimeTracking2x = __webpack_require__(827);
	
	var _icnTimeTracking2x2 = _interopRequireDefault(_icnTimeTracking2x);
	
	var _icnIntegrations2x = __webpack_require__(825);
	
	var _icnIntegrations2x2 = _interopRequireDefault(_icnIntegrations2x);
	
	var _icnProjectViewOptions2x = __webpack_require__(826);
	
	var _icnProjectViewOptions2x2 = _interopRequireDefault(_icnProjectViewOptions2x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var iconMap = {
	  '5511aff4e4b061031401fb4c': {
	    src: _xicn_getting_started2.default,
	    bg: '#B1B9CD'
	  },
	  '5f510e62c9e77c0016384617': {
	    src: _icnProjectViewOptions2x2.default,
	    bg: '#01AAFF'
	  },
	  '5284de2fe4b027e0d843bc97': {
	    src: _xicn_collaborating2.default,
	    bg: '#33C68C'
	  },
	  '526eaf43e4b06c89ec332a52': {
	    src: _xicn_project_planning_level_2.default,
	    bg: '#B970D7'
	  },
	  '5afb35e42c7d3a640ed6de95': {
	    src: _xicnProjectPlanningLevelII2.default,
	    bg: '#FF8063'
	  },
	  '5284df24e4b027e0d843bca8': {
	    src: _icnTips2x2.default,
	    bg: '#F3BD52',
	    portrait: true
	  },
	  '57e9e78d9033602e61d4835c': {
	    src: _icnAccount2x2.default,
	    bg: '#7FD1CD'
	  },
	  videos: {
	    src: _xicn_top_videos2.default,
	    bg: '#FDA0A9'
	  },
	  '5284dea7e4b04fbdf2ac3a02': {
	    src: _icnTimeTracking2x2.default,
	    bg: '#A9CF43',
	    portrait: true
	  },
	  '528a6bcee4b0bb9de0e9a1f6': {
	    src: _icnIntegrations2x2.default,
	    bg: '#5CBCD6',
	    portrait: true
	  }
	};
	
	var DEFAULT_ICON = {
	  src: 'https://placekitten.com/200/200',
	  bg: '#efefef'
	};
	
	function getIcon(_ref) {
	  var id = _ref.id;
	
	  if (iconMap[id]) {
	    return _extends({}, DEFAULT_ICON, iconMap[id]);
	  }
	  return DEFAULT_ICON;
	}
	
	var Icon = function Icon(_ref2) {
	  var _classNames;
	
	  var category = _ref2.category;
	
	  var _getIcon = getIcon(category),
	      bg = _getIcon.bg,
	      src = _getIcon.src,
	      portrait = _getIcon.portrait;
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: (0, _classnames2.default)('card-image', _iconModule2.default.Icon),
	      style: { backgroundColor: bg }
	    },
	    _react2.default.createElement('img', {
	      className: (0, _classnames2.default)(_iconModule2.default.Icon__img, (_classNames = {}, _classNames[_iconModule2.default['Icon__img--portrait']] = portrait, _classNames)),
	      src: src
	    })
	  );
	};
	
	Icon.propTypes = {
	  category: _propTypes2.default.shape({
	    id: _propTypes2.default.string.isRequired
	  }).isRequired
	};
	
	exports.default = Icon;
	module.exports = exports['default'];

/***/ }),

/***/ 350:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _gatsbyLink = __webpack_require__(13);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _categories = __webpack_require__(17);
	
	var _Icon = __webpack_require__(349);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _topicsModule = __webpack_require__(289);
	
	var _topicsModule2 = _interopRequireDefault(_topicsModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function count(num) {
	  var label = num > 1 ? 'articles' : 'article';
	
	  return num + ' ' + label;
	}
	
	var Topic = function Topic(_ref) {
	  var category = _ref.category;
	  return _react2.default.createElement(
	    'div',
	    { className: 'column is-one-third' },
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: category.href || (0, _categories.categoryHref)(category) },
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('card', _topicsModule2.default.Topic) },
	        _react2.default.createElement(_Icon2.default, { category: category }),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('card-content', _topicsModule2.default.Topic__content) },
	          _react2.default.createElement(
	            'p',
	            { className: (0, _classnames2.default)('is-size-4', _topicsModule2.default.Topic__name) },
	            category.name
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: _topicsModule2.default.Topic__description },
	            category.description
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'has-text-link' },
	            count(category.articleCount)
	          )
	        )
	      )
	    )
	  );
	};
	
	Topic.propTypes = {
	  category: _propTypes2.default.shape({
	    articleCount: _propTypes2.default.number.isRequired,
	    description: _propTypes2.default.string.isRequired,
	    href: _propTypes2.default.string,
	    id: _propTypes2.default.string.isRequired,
	    name: _propTypes2.default.string.isRequired
	  }).isRequired
	};
	
	exports.default = Topic;
	module.exports = exports['default'];

/***/ }),

/***/ 456:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Icon":"src-components-topics----icon-module---Icon---9Bzo0","Icon__img":"src-components-topics----icon-module---Icon__img---1S7gp","Icon__img--portrait":"src-components-topics----icon-module---Icon__img--portrait---1LTvD"};

/***/ }),

/***/ 819:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 820:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 821:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 822:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 823:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 824:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJgAAAB+CAYAAADY39i+AAAAAXNSR0IArs4c6QAAC+5JREFUeAHtXetvFNcVP7O7JsUPGrAwC4VETfp2mhTSihQRwqOhQWob1f3SSlX6oTRSpX7K31HxqRFS6lSqFKn5EqoUJCiIR8DQOC0hIdCkzaOKMev1Gts8bB727k7Pbz2zXtazs6+ZuXNnzpFWM3Pn3nPu+c1v771zZuZegyIipml+lV35seXOQcMwPo6Ia1q7kdC69vdXHuRaYf1sot2fQ44CRyASBOPW6wGLWDaAK6w0+1i2ihCIBMEYu9UO+DmlOWSTJD8RiArBNjmA5JTmkE2S/ERAe4JxV/gIA+REpk3WOT/xE911ENCaYBaBBlx8HBCSuaATwCkjABuemmDCYECP8RVaLaeWy8neu5yI3wSHL+45ZZA0fxDQhmBMLDvOhVBEO3KTC0ucrB0EmyirUxdpx7macM8xKwgqcTJHaLxP1Ilg3nsvGn1HQCeCHWQ00L21K6Uusl0lUr4xBLQZg9nuyCDfRkKPrXYEq4TVCkEMcFp3ZXrF/gzvH+A7x88q0mQ3QAR06iKXwGIR58CSE4sJQq5FLJTsaU0wIGaRDDGuanlXWq5qSII/1p5gFmSOBAseTrFYjUBUCDZR7RgfO6U5ZJMkPxGIBMG4K8Tjn8oQxk0rzU/sRHcDCESCYJafdpxM4lwNXHjJIggIAoKAICAICAKCgCAgCAgCgoAgIAgIAoKAICAICAKCgCAgCAgCgoAgIAgIAoKAICAICAKCgCCgAgHlH30MTY71FwrmXrNo7CaDHuIPOWp9wKECn9Db5PfeZsikESNhHk0mjcGtvWsvh6nSygh22TSX5XLZfVyB3zKpovRemrLry2QrmkT7+/rSL/UbxpyyilQYVkIwkGtiPHvYJHNnRV1k1yMEDDJOrF6T3hMGkilpOdByCbk8YpODGmALjB1OBZ4UeAuGMVc+TxelW/T3WqO7TKXocdVjssBbsNKAXsZc/rKLteMPDKx9N1THQKrOec9Pl+4W+bZHxH8EFrD21g4T156nDYrrzrMWeAuGUIS3Lou2mgj4g7U9T9sKtlt3nrXACcb/AIlz1WSEtye8xpr1Nb0eQeAE8xZC0RYwAk5rDzillaslBCtDITsNILDJIY9TWjmbEKwMhey4IcDd4yN83olMrusRCMHcUJVzJQQscg24wFFzPYLAwxQulZRTIULAGtA3uh4Bbtxe4DKYRgu/8noEQrAQXdQwVIVJYse5EIZoVtCFlrpR1nOT9w9KF9kshNHPb8e52vW0FCer24Kdyo3t4ecOr5SsGcaL2/vWHm7XspSPDwL1WzAml2nSevzKRIsPPnH01J5nrV3fS12k69sUQxMTPfOFeWRclESqZ0dfH6YHb0lOZjOhfhBZLBQpM5qhz/93haanpun2zB2anZ0t+drV1UWd3ctp5aqV9PCXN9C69esokaz/H20JKI8K7Uivc73Gtcw0Oci31TQ3yDeNwrfskvY2lSj28/6wfRyV7Z3bd+j88AX69D+f0tzcvKNbN67fIPzGRrP074sf0rJlHfTo1x+lJzdvpOWdyx3L6JpoTUE6yvUfZbJd4u0A/2o95qu5HoHrGKxQLO6tBqhQKP6a0yJDsEKhQBf++T5dunCJ5ufz1e66HoOIH37wEX3y0Sf02MbHaOP3nqBkMulaRseTTLbPmGQHuO4v1Kh/zfUIarbvp7PZXWQaIFOVGHtL56pSdTxEq3XojcN04Z33miZXpb8gJnRAF3RGUUAy9gtdYLW4rkfgSDAQqGiYrzFrl/TfSMM53Uk2NTlFf339b5TL5qoBa/kYuqBzanK6ZR0hL+hIMLc6lwl2MpfrPnMtu/nUeOYVJtAxJlK6VkGcQx7kRRmUrZU3jOloZY68eYxmZxYG717WETqPvHk0qi2Z09oDTmllSBOIczFRrlAxfyufL77N4YjfOLVc5RLWDvIgL8qgLHSUYmbVGUN2jDHX0UPHfSGX7SpIBhuwFSWxBv6VUYW66xEkENsqxbjaREKXOBkG9F52i7Vggw3YiqDYcbJSnKuef653kfUK63YeXSPuFoMS2Op//JuRCmFwK/Yx47evUQwTvFzZi4ZBiHe0JSUdrKstJT4XRpyr2VBEO1WCLdiMsyTwbHH7mnUbiCP0qVTiKSNBg8zSutF25GFS/RFlUBY6wvycEhF6BFGDFtiE7bhKuYu0Hv8ggDrMIYjXiwYhTOF4J8nkyiZM45fb0muP6wIcHv/UitD76QNswvb6h9f7aSa0usthisoabkunj4NATi0Z0hbIldaGXPANzxZViUrbqny27ToSDCdBMv4+eNDOuLg1BxfOLabosIcH16pEpW1VPtt2axIMGZLJxKt2RnvrlGafC/MWb0WoEpW2Vfls23UlWL6YuGxntLdOafa5MG/tV25U1FGlbRX+Vtp0JRgG/pUhDOy38y5YpeGg9/NNvinhZf1U2vbSj1Z0uRKspNCKk+kQ52oFACnjLwLlMEUtM1Zsa0Ot85IuCLghUL8Fcyst5wSBOggIweoAJKfbQ0AI1h5+UroOArEhWKqj7nCzDlStn+7o6Gi9sOYlY0MwfHKmSjq7OlWZVm43NgTD94yqRKVtVT7bdmNDMHwsq0pU2lbls203NgTDl9iqRKVtVT7bdmNDMHzmjy+xgxbYhO24SmwIhjkk8Jl/0AKbYZ+/wk9MYkMwgIg5JDoCDFfAFmzGWWJFMExQgjkkghLYitqkKM1iFyuCARxMUNKX7msWp6bzwwZsxV1iRzDMfrP7R7uoq9u/wCt0w0YUZ9pp9g8TO4IBIHRbzz3/rC8kA7mee3537LtGm4ixJBicX9W7in7685/Q3bv3bCza3kIXdK7qVRfUbdsJjxXElmDAES3ZyOcZmpy8TiZWu25RUBY6oCvug/pqCNW9YlBdE0XH/HExXZuYouvTN6iXW54VX+ymRKKx/12xWKSbN2aYXNOUzxcUeRBus7EnmH15QJDx8WuUy01SZ+cXqLunqxT5T/G6xKnUwrSYyJPn9aDxtfbMrVm6ffsuVpa1VcjWAQEhWBUoIMzsLGaWVvcdZVWVtD5srC/Q2kWpvEoEhGAq0Y+BbSFYDC6yShdjS7BLvJDCH36/sASTlxcAOqFbZAGBJdOU+w2MyqVkcAd4nuezf+vYWcqNu06O3DYMfWtW0zM/2FJ6mwJ3oqqk1aVkvKpvLAiGuVnPnRmmoRNv061bLS+z1BLmPT3dtHXnU7Tl6c1KgrBCsJYuW2OFpqeu0+nj52j43L9o7t5cY4V8yrXsgWW0ect3aduuLbyY1oM+WVmqVgi2FJO2UzKjY3Ty2BC9f/4DQrQ9TIKnBE88+W3a8exWfpV6re9VE4J5CPF/eVGqU0eHCFsd5Gvf+Apt372VsPVLVBNM3ejTI0TRQr3HLdUpbrHQcukk+CPgh5ZsO7do3+GWrdHnoLr4qe0gH2MqjK1OnzhH0/wmQxRkZe+DtG3nltJYDWM2L0R1C6YdwQr8wPn439+iMyf/EdUFp0p3m0/v+D7t+uEzlLQetLdKNiFYE8hdvZKhv/z5DcpmxpsopW/W9Lo19Itf/Yy+tKH17ypVE0ybSH7mapZe3jcYG3Lhb4E/EnweY991FS0IhuDon/a/pjyWpeIiY6z5KvuO9890FC0IdujAEbrOQdO4Cnw/eOCwlu6HnmBT16Z53cWLWoLrZaWBAbDQTUJPsLOneUHdkEXjVVxkYHD2NNYq00tCT7DRkYxeiPpY29GRqz5q90d16Ak2lsn547mGWnXEIvQEu80LrIssIKAjFqEnmJBLbwSEYHpfv9DXXggW+kukdwWFYHpfv9DXXggW+kukdwWFYHpfv9DXPnCCGYYR7Gc9ob8E/lUwDFgHTjAyacQ/SEXzfQiEAOvACWYkzKP3gSAHviEQBqwDJ1gyaQxy0x2ub8l8u8TqFANjYK2uBguWAyfY1t61l3nKtv2qHY+6fWAMrFX7GTjB4HBfX/olg4wTqp2Pqn1gC4zD4J8SgvUbxtzqNek9ZBgvS3fpHQ1KWDKmwBYYe6e5dU3KPry1APjd0OTY/kKB9ppFYzcZ9BBPYdndujvxK8mkmsGdOQb0vMbEYBi6xcqr8H9FGfcFe+X/DAAAAABJRU5ErkJggg=="

/***/ }),

/***/ 825:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFwAAABUCAYAAAAPvFA1AAAAAXNSR0IArs4c6QAAAjNJREFUeAHt3cFNA0EMheEM4kwFuVIMB9pIARRCAbSRcjiSCtLAYkfaGyKObb2B7L/SKoGMx/G31iIRSxnLsjzvdrtXO5/svOfjbMUdxxiftxRpPi+2/sPO/S1xP6w92e8OwzZ8syf3jr3Wfzbw9/WHyKP5fNm6Kvaa6vRgz7aC7UVnau3C9vx7B+cQCgAuxPZUgAMuFhCno8MBFwuI09HhgIsFxOnocMDFAuJ0dDjgYgFxOjoccLGAOB0dPgHcPwnZyjG9Vu/wo53T34jginuNXuvUY0zN/g+S20dsS+fb5B7eqRnYC/AAUucSwDs1A3sBHkDqXAJ4p2ZgL8ADSJ1LAO/UDOwFeACpcwngnZqBvQAPIHUuAbxTM7DXo/2rgPnwAFTXEu/wLQzju5ePKnutUw8Hz8xMT33TheTTa+UeXrh6mVDAM2qFGMALeJlQwDNqhRjAC3iZUMAzaoUYwAt4mVDAM2qFGMALeJlQwDNqhRjAC3iZUMAzaoUYwAt4mVDAM2qFGMALeJlQB9/CqPJqM71WB2c+fL0cgkfmw68gMx9+Beivv8wfTfEVAhxwsYA4HR0OuFhAnI4OB1wsIE5HhwMuFhCno8PF4MyHi8G9w5kPF6I7+PSZaWG902vlHi682p4KcMDFAuJ0dDjgYgFxOjoccLGAOB0dDrhYQJyODgdcLCBOR4cDLhYQp6PDARcLiNN5h0+fmRbWnKnVv+m167h8gSnz4b9zHuzlDvTLV/R+A96ZP6WHV9p5AAAAAElFTkSuQmCC"

/***/ }),

/***/ 826:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 827:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFgAAABYCAYAAABxlTA0AAAAAXNSR0IArs4c6QAABUBJREFUeAHt3L1v1EgUAHAPQaJB6SjuEAitRAFl4AokkCgQHZBbihTRFXw0V1xzugL+AwqoKGigAgokWImkO5BIBUWiICGd4HQSDRIUdKtrToIz723meSfZZ++O582MsceS4/F4xn7+7ezsrDe2yiJNeZ4fhkOf04dfVUr9EykUq8Paxr3Lau+yhRF3Xs8ELXsEP3uzijsKMLSCPRqWCOZ1Hq03clkn7ijAoLePEeTymGJRs7gYubwiyFjAC0UE4wSXN97ajBQXI5dXRBscGN5mPTg6F9SC3lYE16RE3biDAusg+xVw/SYiu8StKk5WZBMEhx9o2E9hq+VaLnecTcjE+TMM3/7jCvjOk4rbGzAESONcHIq5TEOoHGycLB23zy6CxosuuFgXX6CQ42TRuH0Cu8K2or5P4FUQwre36zTqIlx3YlFfNG5vfTCdkNSHBe0v1FIqbu/AJggE3YP1Psx7zXwj/S+kBzByeG/kRU+6xO2zi5iA0XCDiQ3jjMbhYmgucQcFNoLFMe7OabNpLdcMUMdmHXdwYB00G6h5Qg1NW8cdC/gzA8jlMcWiZnExcnlFkFGA4e2GX3/NIdxQ5xWBNTFRJ+4owBqPxpuhx7mur933GrfreW/VhyHVIswf9Lwos9e0l5EAoC7B/AVmmjC9lHgEBBASZhM3IQu4lrVcwqVlasl1sUGwrOUSLi0Tsi2yBW5CDoCbkGdFrtFyCZeWqbsowxbATcgBcBPyTmTBlku4tEzdhUfchBwA10Tu1rWLgLiE/GFn1+S6HvNyZWXs95/+eR4KPIR5rrJg2mgv8FP/6tLxi5e/PHu5/oKaVoAlftiJdxGNax2Im6v/H+Z5Nvf85cah3sH9a70DPx6yf5msanyF0svwi8UTq1ozFG4UsIlLsQdAJtxHdEzJZWOAOVw6UY/IXnEx/kYAV+F6RPaO2wjgWXA9IAfBjQ5sgyuIHAw3KnAdXAHkoLjRgF1wHZCD40YBlsCtgRwFNziwJK4FcjRcjDHYP2D7wCVkXN7449e1MyeOnzbzIC2OC1+n6e4pPNTUu5+CXOzxjYtneu3mndPPX22sYVpP4rh6v3QX0jysT737yTtwCFwSNZC94ELrtX5KgFfgkLiEfP3WnVMPVp714cKNj2sL3J31XB6Fk3kDjoGrVPZV5buWf7lwdqU4Q9nEArM7Lq8o5gU4Ju764K6PlptB99ADNQ6z8ikB4sAtxu0XzXIyUfqUANFhWptw9Qea81MCxIDbgmuMc3EY5jINofKqCHBbcFETgH+HhSsu7gqnoXMf3CbcLRPZv07ALcWlu4hcpd26iJbiFqhRP+Tajlso6wRg4xgYh2nWTwmw7iK6hovG8LUbH68wwHTJVPqUACvgLuISqEbepHVjWfmUgJmBu4xrYhppSnLotG22iz0Jt/Di7qzn8ooKU1twwi2ssC+2fkpAJXDCHeMaKRonj8a5Rj6bLP2qnHBZL+tMFjjhWjuWVpgATrilVrU2bANOuLUMKysVwAm30qn2xhFwwq3tN7WiOnbxyqLK8sd4T8TU0kIF6NdfXz9QCoUpspvdKs9u5wH/071LuPgKVX7REHkJjZ10DXcEnKvsNzxxw8FLsou4CDn36e3rd/uPHPs7U/nPsO6lRXcVdwSMfz6+3fzLF3KXcQtgX8hdx90GLI2ccFGUGZ5JdBcJdwuXBcZMF+SEO8YtBa6LnHC341YC2yIn3EncqcCzIidcHncm4GnICbccd2bgMuSEW41rBUzIPxxdeKMydRLmYa7UpY3BPfHHsEwP+/sp8Q0eBy4eXx/tiAAAAABJRU5ErkJggg=="

/***/ }),

/***/ 828:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAB6CAYAAABJPva/AAAAAXNSR0IArs4c6QAACrVJREFUeAHtXWmIHjUYzrRfq611tWJRW1S6XigoUhTx+CMWjx/1WLGCiEIRVEQUQVBEwfpDRK0oKPpDfxWRCotaoSKiKPUo6ta7nqst23pUrW5rz7Xj88xmvh2/Jpkzs8l0AtmZeZO8ed73mSSTTObbQDgSwjA8AVAWSTgrgyD4zhFotcKYUmtt5spIRp+MMTHmEg1MdYIQtI4DJBGxi/ukLL7eb45OEAJvz1F4XCVTZGuWyBVCFijcqpIpsjVLNOmEoGvqh0tVzl8g05rl8RRrJpUQ6fABA8aB/Y2UwOAMK0lwMAdwjg9sFaqWoap3CELGzXgc3qXK0BRZbYSAiHiewUfbMmEUhRs7T6mzy4rnGWXIYFkS2th5Sqesd9ryZg8kegZmTG3ZdbaQlQDE7qZsiLqsskpqLB/3DJladm0tRK5NLdufBnVpa3LMjFYgTA8mtRES35ESzAiuRwD4CxwHEGfF6T3HbbgeRJnhHrkvl6rVBspovzLU2WXtA0A6enCfhAmBz2TQigUTpnTPVLJu4qQSQhSSlKEuoomTIY9bhkDr74cpKucbVyAmnRDpfyUhE9z4dSbJYFesC9oViNrHEA3CzQq5SqbI5oZIDuBZVyA4Zl6HMrwRGbsrEE4Qgq5pF8CNAlgfIsMoZeOnbv8F7jIrEOzSom5N2r/SlS6LXo/nKSSG576EeJ5RFi9vxkW1rWWVRetqedzZdwBb3LLLwhx1qYWUNWayysctu2z9Uc/QtpCybpTl0VIqea3QElIRIUk1IIdzkAHE3CsQbZeV9GRF53JCO2hQp12BaAkxeK1MkiRlSKHDuALhxDxEAbqQaOGKH04Ve4NLsW5xChZl5kLJ3FCEPIpABJtwQAw3Yb3mKzElfOWNxcd9zjSLgYQs6NGvIqmbxfsxZJwEsUSEwWXou+d3Lctwgrv4RxGEL4sp4jkb5MiB/u4eKA+aJr3eEgIijhFjwQMw9lq0glJdL1rPXuhZLjrhvSBmQ48DS12ClOQ8hSsQy0wKvSPkqhXh9C3/Di+FUbeHoeCjZoUh2BkE4eOzp/bf9+LiYHcVikFIvLRCdamvcL0i5JIVP8/ZM7Z9MBTivCqcpdMBp6ye1pk5sGrxUbUvcHpDyMXPD5+2R4hXMCgfq3NktfJg/TQhLn3tmv7PqtVr1uYFIREZQfiuCLUTLbOVRVMDsW1aGJxbJymlBsOiduYpF3VTbBl1k0GQqJOtkhjyYC6T12lCOIBzzKivm1K5MjyWGIhFlVq1zGlC/tw7/IDtATyLQ4lBPtllyV4qT+oYkvexrRSaRGHOM8Kx4Bu0jgMT4kk8xSNxJzyp6nlKr0FZWkj8RqwPhevbUxtN+lwhg24DlvGJaK8PK702EiKn/iQiDrV8+xcth2AGHlfq0PFaic0aJCMhqFX1dKGSVQtwr1hSdjmkWkDj2iJMwGZDd6wzjZDelUqWU8lifdUcsVBYjSILWixj0xKC7qof5qicb9x5V9YFnASi7vll9dgqT2zEaEu/8n2IJGPAUCl33mnfehnKpSaNBQLvM1KzGTPM6ARi8cmHirPnzRTzZmEBBGHjtj3i/Y3bxYp1f4kdY+UqiDAK8ZkRRMHELiFwcJ6X9NqddwVxJIqFJycucp+efsSB4s6z5ogjDhonIlZw/OwDBOOF82eJh9dsFp/8ujNOKnAsh9FUYQdExMvDyacpU5lkGru0qFuDnlGcpy4vJwurz/mmr9gdTDIePv8obuBWq4aURDHPnW/9XIKU6G2kto4yCRxD4nlGGT0sW9U8JXrlmhcMuym2DBMZsU7mYV6WKRgKYcxSl3ZQz1LYRp74HXhe3Rwzerspkw7mZZkioSjGLHWRkEp33mWp1EaeczCA5w0c9F0LHTRf/i6VM9/+cXcI7sAT8zpqrnyaylMufgLLU4Z55Q6WvMUy5e8+ZYEYbv8fYcQAPZnf/nG7Tm5CZkzL3/sWKSO9SoxWgtIKkMOPLAcNNVqZg4zXh31Tzgd7GJWE0B+SlCGFb4w77xT5c4qCdTkL1J+dG+0sBS0hsj4lIZawjKudio1rrgfserQFMY0Q1TYYlawyfNxBiNb5Y2UKK1ZEbDZ2OcYwjYSgcg70nIHHoZ5v/7i909VgGZuREOmTeJ4SLY3U4ifstZXbO2upLmslESZgy5q/SL5UQtBKvkNcJmMtv6Uru4TlRQyyXGa5ze6K2FMJsWygXj02PmPJiV2mIyHYyc3YtsE4SwjuxA1hIB637YCs+rkJm5iy5i+az1lCaNBhU/rvxXrs6qLGVVWOGLgjvip9Jj1OE8JPArgLHdPU9SYj7KZh0zUwVPV5QhpWpwkheH4SwF3oWNHjb2fVG7jZGnXX+VmC84SQAe4+5y70elsKWkbNO99pqxeExKRM78w4s44xhXWwrjo/Q6CNDN4QQrDsOmZ3+i/A4/BDdh6J+UmbeIh11NlN0bY4dN+HxALXj3JwvQtbOp8KPPjo03V/Vo6Pe20XvvDDY3ipViiwrO39unmMRnfZjEA2iliCJSGnfODVGFLE4b6VaQlxjLGWkJYQxzzgGJy2hYAQPA8EiFcgvoG4CXEn4reITyP2O8aZH3DguKKBZCw3FP4LaVZ/ysMPD+dEaXBoWtJtaRmQvhHxYELCcTriDYjvIW5B/APxTcRbEafmhN3c7HBG0fBpxoK3IN+hiO8Y8g8h7fDmejmHZQYnVZX0KhS9mEHZKuSJJps4Xo/4IeJWxHWIjyJGLU1nmlOzVB3ILHIYWmimnkW3zLMDxxkZ85+DfFcj3qbI/z1kZ2CB4G9FWnNEJMShkNaSntF5vm0hOs/YlY+ghRytqqIlROUV+7J/QYjy1Uc7MbTvfFUNu1VCypQs6TLXJcdYMBt1LUW8EPF4xH1unLXP3gOxt0G7AdA5QkAGn+P5GYSyj/WWgv8D3/r/y4mrfe68iaRJO3sENTeZDDp2i867LhKyUAe2QXKvCJnXIMfrTPlNl+BiC9FhbZJ8RGdMS4jOM3blLSF2/Ztbe0tIbpfZLdASYte/ubVv1JXwdgyZftAhXZuS512huyf8XyXaX6vwlpCjz7tckAhGnnsU1mNhcY8Or3OrvXynoQPbEPnrIOQinS3ethCdQR7IvzVhbAkxecdOWkuIHb8W1toSUth1dgoaCWkHdTtO12nli6mZGNT56KsM7RiidIs14dcmMlhrS4g13ysVp/6rVxcJ+UdpSjOE/HFRY3CREO7sa2rwsoWsaiobsCuVEBefso4E8GHErPtofeHvbwzoqb9t7lyXBdC/wMNP++LlHDhTWwd1OUeINPB+HH+S5005fJLFECcJQSvhVv1rEMeyGOFJnrVZcDpJCIGDlPdxuCuLEZ7kyUSIc4N6r3PxeuRZyJb0yj273g28B+Mm49EYnG0hCdQ34fztxLWPp/y17lQyaJjzhMAQvu68EtHZnx+nI1PCxynp3WTnCSFSkPIHDosQt/Law/BRVsxeEEJjQMqXONyY1TDH8n2YFY/zg3qvIRjkX4CMX7j6Evj1bh9uqEyP8N60kIT3b8b574lr10/XZiWDhnhHCIzjtxVPuM5CAt+axHnqqXeESIuexNGX9yYfpLKQyOAlIWglf8KGlxJ2uHzafEKk91e7zILEtgk3z4Y8OL1sIdJA7Q7yPA6wnPe9vPr/A54VuBXhFdzsAAAAAElFTkSuQmCC"

/***/ }),

/***/ 351:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(225);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _lodash3 = __webpack_require__(131);
	
	var _lodash4 = _interopRequireDefault(_lodash3);
	
	var _Topic = __webpack_require__(350);
	
	var _Topic2 = _interopRequireDefault(_Topic);
	
	var _topicsModule = __webpack_require__(289);
	
	var _topicsModule2 = _interopRequireDefault(_topicsModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var videoTopic = {
	  id: 'videos',
	  articleCount: 1,
	  name: 'Top Videos',
	  href: '/videos',
	  description: 'Learn fast with these helpful videos.'
	};
	
	var Topics = function Topics(_ref) {
	  var categories = _ref.categories;
	
	  var categoryArray = (0, _lodash4.default)(categories);
	  categoryArray.unshift(videoTopic); // add curated topic for videos
	
	  var chunks = (0, _lodash2.default)(categoryArray, 3);
	
	  return _react2.default.createElement(
	    'section',
	    { className: 'section' },
	    _react2.default.createElement(
	      'div',
	      { className: 'container container-960' },
	      _react2.default.createElement(
	        'h1',
	        { className: (0, _classnames2.default)('is-size-3', _topicsModule2.default.Topics__heading) },
	        'Browse by Topic'
	      ),
	      chunks.map(function (group, i) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'columns', key: i },
	          group.map(function (category) {
	            return _react2.default.createElement(_Topic2.default, { category: category, key: category.id });
	          })
	        );
	      })
	    )
	  );
	};
	
	Topics.propTypes = {
	  categories: _propTypes2.default.objectOf(_propTypes2.default.shape({
	    id: _propTypes2.default.string.isRequired,
	    articleCount: _propTypes2.default.number.isRequired,
	    name: _propTypes2.default.string.isRequired,
	    slug: _propTypes2.default.string.isRequired,
	    description: _propTypes2.default.string
	  }).isRequired).isRequired
	};
	
	exports.default = Topics;
	module.exports = exports['default'];

/***/ }),

/***/ 289:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Topics__heading":"src-components-topics----topics-module---Topics__heading---1fwN-","Topic":"src-components-topics----topics-module---Topic---32tln","Topic__content":"src-components-topics----topics-module---Topic__content---omVdW","Topic__name":"src-components-topics----topics-module---Topic__name---cyTZJ","Topic__description":"src-components-topics----topics-module---Topic__description---36HDM","spinAround":"src-components-topics----topics-module---spinAround---Q3Kpb"};

/***/ }),

/***/ 182:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Function borrowed from https://www.npmjs.com/package/sec-to-min
	 *
	 * Gatsby has a problem with npm modules written in ES6
	 *
	 * @param {number} seconds
	 */
	var secToMin = function secToMin(seconds) {
	  var secs = Math.round(seconds);
	
	  if (secs < 0) {
	    throw new Error('Seconds must be positive');
	  }
	
	  if (secs < 60) {
	    if (secs < 10) {
	      return '0:0' + secs;
	    }
	
	    return '0:' + secs;
	  }
	
	  var minuteDivisor = secs % (60 * 60);
	  var minutes = Math.floor(minuteDivisor / 60);
	
	  var secondDivisor = minuteDivisor % 60;
	  var remSecs = Math.ceil(secondDivisor);
	
	  if (remSecs < 10 && remSecs > 0) {
	    remSecs = '0' + remSecs;
	  }
	  if (remSecs === 0) {
	    remSecs = remSecs + '0';
	  }
	
	  var time = {
	    m: minutes,
	    s: remSecs
	  };
	
	  return time.m + ':' + time.s;
	};
	
	var Duration = function Duration(_ref) {
	  var seconds = _ref.seconds;
	  return _react2.default.createElement(
	    'p',
	    { className: 'has-text-grey-light' },
	    secToMin(seconds)
	  );
	};
	
	Duration.propTypes = {
	  seconds: _propTypes2.default.number.isRequired
	};
	
	exports.default = Duration;
	module.exports = exports['default'];

/***/ }),

/***/ 183:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _popoverEmbedModule = __webpack_require__(219);
	
	var _popoverEmbedModule2 = _interopRequireDefault(_popoverEmbedModule);
	
	var _btn_play2x = __webpack_require__(261);
	
	var _btn_play2x2 = _interopRequireDefault(_btn_play2x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var responsivePadding = {
	  padding: '56.25% 0 0 0',
	  position: 'relative'
	};
	
	var responsiveWrapper = {
	  height: '100%',
	  left: 0,
	  position: 'absolute',
	  top: 0,
	  width: '100%'
	};
	
	var embedStyle = {
	  height: '100%',
	  width: '100%'
	};
	
	var PopoverEmbed = function (_Component) {
	  _inherits(PopoverEmbed, _Component);
	
	  function PopoverEmbed() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PopoverEmbed);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.playVideo = function () {
	      if (_this.video) {
	        _this.video.popover.showAndPlay();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  PopoverEmbed.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    var _window = window,
	        wistia = _window._wq;
	    var _props = this.props,
	        id = _props.video.hashed_id,
	        setPlayFn = _props.setPlayFn;
	
	    wistia.push({
	      id: id,
	      onReady: function onReady(video) {
	        _this2.video = video;
	      }
	    });
	    if (setPlayFn) {
	      setPlayFn(this.playVideo);
	    }
	  };
	
	  PopoverEmbed.prototype.render = function render() {
	    var _props2 = this.props,
	        className = _props2.className,
	        video = _props2.video;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)(_popoverEmbedModule2.default.PopoverEmbed, className) },
	      _react2.default.createElement(
	        'div',
	        { className: _popoverEmbedModule2.default.PopoverEmbed__btn, onClick: this.playVideo },
	        _react2.default.createElement('img', { alt: 'play video', src: _btn_play2x2.default })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'wistia_responsive_padding', style: responsivePadding },
	        _react2.default.createElement(
	          'div',
	          { className: 'wistia_responsive_wrapper', style: responsiveWrapper },
	          _react2.default.createElement('div', {
	            className: (0, _classnames2.default)('playButton=false', 'popover=true', 'videoFoam=true', 'wistia_embed wistia_async_' + video.hashed_id),
	            style: embedStyle
	          })
	        )
	      )
	    );
	  };
	
	  return PopoverEmbed;
	}(_react.Component);
	
	PopoverEmbed.propTypes = {
	  className: _propTypes2.default.string,
	  setPlayFn: _propTypes2.default.func,
	  video: _propTypes2.default.shape({
	    hashed_id: _propTypes2.default.string.isRequired,
	    thumbnail: _propTypes2.default.shape({
	      url: _propTypes2.default.string.isRequired
	    }).isRequired
	  }).isRequired
	};
	
	exports.default = PopoverEmbed;
	module.exports = exports['default'];

/***/ }),

/***/ 353:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _VideoListItem = __webpack_require__(184);
	
	var _VideoListItem2 = _interopRequireDefault(_VideoListItem);
	
	var _ListHeader = __webpack_require__(264);
	
	var _ListHeader2 = _interopRequireDefault(_ListHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VideoList = function VideoList(_ref) {
	  var useEmbed = _ref.useEmbed,
	      videos = _ref.videos;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_ListHeader2.default, { href: '/videos', text: 'Popular Videos' }),
	    _react2.default.createElement(
	      'ul',
	      null,
	      videos.map(function (video, i) {
	        return _react2.default.createElement(
	          'li',
	          { key: 'popular-video-' + i },
	          _react2.default.createElement(_VideoListItem2.default, { useEmbed: useEmbed, video: video })
	        );
	      })
	    )
	  );
	};
	
	VideoList.propTypes = {
	  useEmbed: _propTypes2.default.bool,
	  videos: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    thumbnail: _propTypes2.default.shape({
	      url: _propTypes2.default.string.isRequired
	    }).isRequired,
	    duration: _propTypes2.default.number.isRequired,
	    name: _propTypes2.default.string.isRequired
	  })).isRequired
	};
	
	VideoList.defaultProps = {
	  useEmbed: false
	};
	
	exports.default = VideoList;
	module.exports = exports['default'];

/***/ }),

/***/ 184:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Duration = __webpack_require__(182);
	
	var _Duration2 = _interopRequireDefault(_Duration);
	
	var _PopoverEmbed = __webpack_require__(183);
	
	var _PopoverEmbed2 = _interopRequireDefault(_PopoverEmbed);
	
	var _videoListModule = __webpack_require__(220);
	
	var _videoListModule2 = _interopRequireDefault(_videoListModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VideoListItem = function (_Component) {
	  _inherits(VideoListItem, _Component);
	
	  function VideoListItem() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, VideoListItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.play = function () {
	      var playFn = function playFn() {};
	      if (_this.playFn) {
	        playFn = _this.playFn;
	      }
	      playFn();
	    }, _this.setPlayFn = function (fn) {
	      _this.playFn = fn;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  VideoListItem.prototype.render = function render() {
	    var _classNames;
	
	    var _props = this.props,
	        video = _props.video,
	        isGridItem = _props.isGridItem,
	        useEmbed = _props.useEmbed;
	
	    return _react2.default.createElement(
	      'div',
	      {
	        className: (0, _classnames2.default)(_videoListModule2.default.VideoListItem, (_classNames = {
	          'is-flex': !isGridItem
	        }, _classNames[_videoListModule2.default['VideoListItem--in-vertical']] = !isGridItem, _classNames[_videoListModule2.default['VideoListItem--in-grid']] = isGridItem, _classNames))
	      },
	      useEmbed ? _react2.default.createElement(_PopoverEmbed2.default, {
	        className: _videoListModule2.default.VideoListItem__thumbnail,
	        setPlayFn: this.setPlayFn,
	        video: video
	      }) : _react2.default.createElement('img', {
	        className: _videoListModule2.default.VideoListItem__thumbnail,
	        src: video.thumbnail.url
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: _videoListModule2.default.VideoListItem__details },
	        _react2.default.createElement(
	          'p',
	          { className: _videoListModule2.default.VideoListItem__videoName, onClick: this.play },
	          video.name
	        ),
	        _react2.default.createElement(_Duration2.default, { seconds: video.duration })
	      )
	    );
	  };
	
	  return VideoListItem;
	}(_react.Component);
	
	VideoListItem.propTypes = {
	  isGridItem: _propTypes2.default.bool,
	  useEmbed: _propTypes2.default.bool,
	  video: _propTypes2.default.shape({
	    thumbnail: _propTypes2.default.shape({
	      url: _propTypes2.default.string.isRequired
	    }).isRequired,
	    duration: _propTypes2.default.number.isRequired,
	    hashed_id: _propTypes2.default.string,
	    name: _propTypes2.default.string.isRequired
	  }).isRequired
	};
	
	VideoListItem.defaultProps = {
	  isGridItem: false,
	  useEmbed: false
	};
	
	exports.default = VideoListItem;
	module.exports = exports['default'];

/***/ }),

/***/ 261:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 219:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"PopoverEmbed":"src-components-videos----popover-embed-module---PopoverEmbed---1MDsz","PopoverEmbed__btn":"src-components-videos----popover-embed-module---PopoverEmbed__btn---1NyvY","Popover_placeholder":"src-components-videos----popover-embed-module---Popover_placeholder---3KPRV"};

/***/ }),

/***/ 220:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"VideoListItem":"src-components-videos----video-list-module---VideoListItem---3nlRd","VideoListItem__videoName":"src-components-videos----video-list-module---VideoListItem__videoName---3ZMGS","VideoListItem--in-vertical":"src-components-videos----video-list-module---VideoListItem--in-vertical---3yAaW","VideoListItem__thumbnail":"src-components-videos----video-list-module---VideoListItem__thumbnail---3xxIK","VideoListItem__details":"src-components-videos----video-list-module---VideoListItem__details---1wWiY","VideoListItem--in-grid":"src-components-videos----video-list-module---VideoListItem--in-grid---KbftZ","spinAround":"src-components-videos----video-list-module---spinAround---3Y03K"};

/***/ }),

/***/ 17:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.categoryHref = exports.articleHref = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.isActiveCategory = isActiveCategory;
	exports.buildTree = buildTree;
	
	var _lodash = __webpack_require__(42);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _lodash3 = __webpack_require__(39);
	
	var _lodash4 = _interopRequireDefault(_lodash3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isActiveCategory(category, pathname) {
	  var articles = category.articles;
	
	
	  return articles.some(function (_ref) {
	    var href = _ref.href;
	    return pathname.includes(href);
	  });
	}
	
	var flatten = function flatten(edges) {
	  return edges.map(function (_ref2) {
	    var node = _ref2.node;
	    return node;
	  });
	};
	
	var articleHref = exports.articleHref = function articleHref(_ref3) {
	  var slug = _ref3.slug,
	      number = _ref3.number;
	  return '/article/' + number + '-' + slug;
	};
	
	var categoryHref = exports.categoryHref = function categoryHref(category) {
	  if (category.articles[0]) {
	    return articleHref(category.articles[0]);
	  }
	  return '#';
	};
	
	function buildTree(categoryEdges, articleEdges) {
	  var categoryNodes = (0, _lodash2.default)(flatten(categoryEdges), ['order']);
	  var articleNodes = flatten(articleEdges);
	
	  // initialize the tree
	  var tree = categoryNodes.reduce(function (acc, category) {
	    var name = category.name,
	        id = category.id,
	        slug = category.slug,
	        articleCount = category.articleCount,
	        description = category.description;
	
	    var node = {
	      id: id,
	      description: description,
	      name: name,
	      slug: slug,
	      articleCount: articleCount,
	      articles: []
	    };
	
	    return (0, _lodash4.default)(acc, id, node);
	  }, {});
	
	  // populate the tree and return it
	  return articleNodes.reduce(function (acc, article) {
	    return article.categories.reduce(function (treeWithArticles, id) {
	      return (0, _lodash4.default)(treeWithArticles, [id, 'articles', treeWithArticles[id].articles.length], _extends({}, article, { parent: id, href: articleHref(article) }));
	    }, acc);
	  }, tree);
	}

/***/ }),

/***/ 359:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _categories = __webpack_require__(17);
	
	var _topics = __webpack_require__(351);
	
	var _topics2 = _interopRequireDefault(_topics);
	
	var _ArticleList = __webpack_require__(339);
	
	var _ArticleList2 = _interopRequireDefault(_ArticleList);
	
	var _VideoList = __webpack_require__(353);
	
	var _VideoList2 = _interopRequireDefault(_VideoList);
	
	var _liveClasses = __webpack_require__(343);
	
	var _liveClasses2 = _interopRequireDefault(_liveClasses);
	
	var _guides = __webpack_require__(342);
	
	var _guides2 = _interopRequireDefault(_guides);
	
	var _indexModule = __webpack_require__(459);
	
	var _indexModule2 = _interopRequireDefault(_indexModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getPopularVideos(data) {
	  var GATSBY_WISTIA_POPULAR_VIDEOS_PROJECT_ID = ("3590411");
	
	
	  return data.allWistiaVideo.edges.map(function (_ref) {
	    var video = _ref.node;
	    return video;
	  }).filter(function (video) {
	    return video.project.id === parseInt(GATSBY_WISTIA_POPULAR_VIDEOS_PROJECT_ID, 10);
	  });
	}
	
	var IndexPage = function IndexPage(_ref2) {
	  var data = _ref2.data;
	  var articleEdges = data.allHelpScoutArticle.edges,
	      categoryEdges = data.allHelpScoutCategory.edges;
	
	
	  var articles = articleEdges.map(function (_ref3) {
	    var article = _ref3.node;
	    return article;
	  });
	
	  var categoryTree = (0, _categories.buildTree)(categoryEdges, articleEdges);
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_topics2.default, { categories: categoryTree }),
	    _react2.default.createElement(
	      'section',
	      { className: (0, _classnames2.default)('section', _indexModule2.default.Section) },
	      _react2.default.createElement(
	        'div',
	        { className: 'container container-960' },
	        _react2.default.createElement(
	          'div',
	          { className: 'columns' },
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('column is-5', _indexModule2.default.Column) },
	            _react2.default.createElement(_ArticleList2.default, { articles: articles.slice(0, 5) })
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className: (0, _classnames2.default)('column is-5 is-offset-2', _indexModule2.default.Column, _indexModule2.default['Column--offset'])
	            },
	            _react2.default.createElement(_VideoList2.default, { useEmbed: true, videos: getPopularVideos(data) })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_liveClasses2.default, { className: _indexModule2.default.Section }),
	    _react2.default.createElement(
	      'section',
	      { className: (0, _classnames2.default)('section', _indexModule2.default.Section) },
	      _react2.default.createElement(
	        'div',
	        { className: 'container container-960' },
	        _react2.default.createElement(_guides2.default, null)
	      )
	    )
	  );
	};
	
	IndexPage.propTypes = {
	  data: _propTypes2.default.object.isRequired
	};
	
	// eslint-disable-next-line
	var query = exports.query = '** extracted graphql fragment **';
	
	exports.default = IndexPage;

/***/ }),

/***/ 459:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Section":"src-pages----index-module---Section---3cKk9","Column":"src-pages----index-module---Column---231-N","Column--offset":"src-pages----index-module---Column--offset---1es5K","spinAround":"src-pages----index-module---spinAround---3pFBn"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-95fe3db6caef3b924675.js